var _rect, _rect2, _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletConfirmation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 200,
    viewBox: "0 0 640 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 200,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 200,
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 640,
    height: 200
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 200,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.884 207H157.116C157.605 207 158 206.598 158 206.101V206.103C158 206.599 158.397 207 158.887 207H188.878H189.113H211.915H212.12H229.887H233.085H249.901H253V207.098C253 207.597 253.404 208 253.904 208H282.096C282.594 208 283 207.597 283 207.098V54.9011C283 54.4035 282.594 54 282.096 54H267V43.8989C267 43.402 266.596 43 266.098 43H249.901C249.403 43 249 43.402 249 43.8989V89H234V38.4361C234 38.2138 233.916 37.9992 233.763 37.8348L223.18 26.2968C222.816 25.9011 222.184 25.9011 221.82 26.2968L211.235 37.8348C211.084 37.9992 211 38.2138 211 38.4361V99H190V26.8986C190 26.4025 189.603 26 189.113 26H158.887C158.397 26 158 26.4025 158 26.8986V7.42486C158 7.14741 157.874 6.88409 157.656 6.71454L145.541 -2.81118C145.222 -3.06294 144.778 -3.06294 144.459 -2.81118L132.344 6.71454C132.126 6.88409 132 7.14741 132 7.42486V38.8992C132 38.4034 131.601 38 131.111 38H112.889C112.398 38 112 38.4034 112 38.8992V69H91V57.8981C91 57.4016 90.6012 57 90.1109 57H71.8891C71.3976 57 71 57.4016 71 57.8981V206.102C71 206.598 71.3976 207 71.8891 207H87V208H91.8891H110.111H112V206.101C112 206.598 112.398 207 112.889 207H131.111C131.601 207 132 206.598 132 206.101C132 206.598 132.395 207 132.884 207ZM321.924 207H330.924H343.076H347.924H352.076H369.076C369.587 207 370 206.601 370 206.109V146.891C370 146.399 369.587 146 369.076 146H353V95.8945C353 95.4 352.587 95 352.076 95H344V72.2214C344 72.0103 343.923 71.8056 343.785 71.6433L333.208 59.3225C332.84 58.8925 332.16 58.8925 331.792 59.3225L321.215 71.6433C321.077 71.8056 321 72.0103 321 72.2214V206.099C321 206.597 321.413 207 321.924 207ZM426 223H401.904C401.404 223 401 222.597 401 222.098V205H376.904C376.404 205 376 204.597 376 204.099V86.9008C376 86.4028 376.404 86 376.904 86H401V69.9023C401 69.4048 401.404 69 401.904 69H430.096C430.594 69 431 69.4048 431 69.9023V93H443.099C443.596 93 444 93.4032 444 93.9002V256.101C444 256.598 443.596 257 443.099 257H426.901C426.403 257 426 256.598 426 256.101V223ZM313.096 207H284.904C284.404 207 284 206.597 284 206.099V88.9008C284 88.4028 284.404 88 284.904 88H313.096C313.594 88 314 88.4028 314 88.9008V206.099C314 206.597 313.594 207 313.096 207ZM26.9151 214H25.9123C25.7666 214 25.6291 213.967 25.507 213.907C25.3883 213.967 25.2545 214 25.1128 214H-5.1128C-5.6033 214 -6 213.599 -6 213.103V33.8973C-6 33.4012 -5.6033 33 -5.1128 33H25.1128C25.6033 33 26 33.4012 26 33.8973V64H42.0877C42.5908 64 43 64.4016 43 64.8981V106H48.0849C48.5908 106 49 106.399 49 106.892V213.108C49 213.601 48.5908 214 48.0849 214H42.0877H26.9151Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.681 160.648C194.548 157.242 260.168 157.696 325.618 157.676C396.497 157.655 467.377 157.635 538.256 157.614C580.458 157.601 623.823 157.659 663.117 162.886C702.41 168.112 737.26 179.768 740.394 194.053C742.07 201.681 734.766 209.17 727.563 216.419C720.847 223.175 714.131 229.931 707.415 236.688C700.477 243.665 693.484 250.687 683.037 257.141C668.861 265.9 648.383 273.475 623.889 279.021C581.742 288.564 530.097 291.784 479.78 293.791C402.825 296.859 325.065 297.596 247.727 295.987C196.023 294.913 143.02 292.637 97.5858 284.191C40.603 273.599 -28.3173 252.579 -41.9372 227.542C-50.2833 212.202 -58.7324 190.78 -24.4174 179.104C7.52475 168.235 59.6887 165.414 100.153 162.483C109.976 161.773 119.819 161.166 129.681 160.648",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20808 171.934C5.23475 171.906 5.26142 171.879 5.28809 171.851C7.63761 169.456 2.68398 166.901 -2.62849 167.718C-3.3753 167.833 -4.10512 167.959 -4.80828 168.093C-10.1717 169.108 -16.1049 170.395 -21.4683 169.367C-23.1946 169.037 -24.4361 168.323 -25.1368 167.502C-27.159 165.128 -31.8459 163.504 -37.2529 163.532H-37.2917C-41.6101 163.554 -43.8287 161.049 -40.6887 159.651C-35.3787 157.288 -25.2968 156.499 -17.179 156.524C58.2504 156.755 397.643 155.497 422.939 155.486C504.426 155.448 585.941 159.323 665.825 167.033C677.119 168.124 688.704 169.354 698.206 172.446C703.254 174.089 707.604 176.389 710.262 178.988C713.162 181.819 704.297 183.948 701.036 181.206C697.913 178.578 695.04 175.671 689.654 174.337C682.604 172.591 674.144 175.396 671.865 178.772C668.846 183.243 657.331 185.033 649.848 181.931C648.685 181.447 647.647 180.894 646.781 180.278C643.598 178.014 641.316 174.688 635.577 174.573C628.101 174.422 626.453 179.721 620.292 181.718C612.266 184.32 602.361 180.346 594.709 177.485C581.642 172.6 564.958 170.517 548.662 168.916C475.124 161.688 399.362 161.832 324.316 162.67C235.029 163.676 203.678 164.596 114.418 166.397C102.171 166.644 83.004 165.8 34.3018 173.336C26.7805 174.5 19.4094 176.002 11.5026 176.218C6.67744 176.351 3.22469 174.014 5.20808 171.934",
    fill: "#249A9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.485 204.811C355.091 202.426 331.688 200.791 305.75 200.257C304.984 200.241 304.207 200.231 303.436 200.217C314.593 198.382 321.59 196.185 321.59 193.803C321.59 188.972 292.098 184.184 257.78 181.963C257.112 181.948 256.435 181.937 255.762 181.923C251.397 179.667 248.196 177.225 248.196 174.678C248.196 167.999 275.494 161.778 282.896 158.07C277.126 157.973 207.007 157.569 187.356 158.953C170.909 162.646 167.443 169.172 167.443 174.764C167.443 183.715 193.463 191.316 229.683 194.089C216.141 200.253 147.07 209.165 172.048 210.082C172.224 210.089 172.595 210.072 173.108 210.038C164.649 212.438 159.891 215.142 159.891 218.003C159.891 219.415 161.049 220.792 163.246 222.112C173.656 228.37 207.326 233.367 250.717 235.193C252.562 235.269 254.424 235.341 256.304 235.408C259.742 235.529 263.235 235.629 266.776 235.71C268.618 235.752 270.471 235.789 272.339 235.82C277.22 235.899 282.185 235.94 287.219 235.94C357.541 235.94 414.549 227.91 414.549 218.003C414.549 212.785 398.731 208.09 373.485 204.811",
    fill: "#249A9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.122 235.82C277.254 235.789 275.4 235.753 273.559 235.71C270.019 235.629 266.524 235.53 263.086 235.409C261.206 235.341 259.345 235.269 257.499 235.192C214.11 233.367 180.44 228.37 170.029 222.112C167.833 220.793 166.673 219.415 166.673 218.003C166.673 215.142 171.431 212.438 179.892 210.038C179.377 210.072 179.007 210.088 178.83 210.082C153.853 209.165 222.923 200.252 236.465 194.089C200.245 191.316 174.226 183.715 174.226 174.764C174.226 169.172 177.692 162.646 194.139 158.953C205.238 158.171 232.432 157.961 255.042 157.942C231.391 157.923 199.592 158.091 187.356 158.953C170.909 162.646 167.443 169.172 167.443 174.764C167.443 183.715 193.463 191.316 229.683 194.089C216.141 200.252 147.07 209.165 172.048 210.082C172.224 210.088 172.595 210.072 173.108 210.038C164.649 212.438 159.891 215.142 159.891 218.003C159.891 219.415 161.049 220.793 163.246 222.112C173.656 228.37 207.326 233.367 250.717 235.192C252.562 235.269 254.424 235.341 256.304 235.409C259.742 235.53 263.235 235.629 266.776 235.71C268.618 235.753 270.471 235.789 272.339 235.82C277.22 235.899 282.185 235.94 287.219 235.94C288.62 235.94 290.013 235.936 291.402 235.93C287.261 235.918 283.156 235.885 279.122 235.82",
    fill: "#20898E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.092 59.8783C362.071 59.8544 362.032 59.8793 362.048 59.9079L370.424 76.0215C370.656 76.4663 370.332 76.9979 369.831 76.9979H344.395C344.025 76.9979 343.726 77.2966 343.726 77.666V173.756C343.726 174.125 344.025 174.424 344.395 174.424H376.979C376.993 174.424 377.005 174.412 377.005 174.397C377.005 174.397 376.858 81.8378 376.848 76.4023C376.847 76.2391 376.787 76.0855 376.679 75.9643L362.1 59.5996",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 15,
    width: 356,
    height: 278
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.802 292.019H421.883V15.4834H66.802V292.019Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.599 174.423H370.879V76.9971H337.599V174.423Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.6 174.423H370.88V76.9969L362.1 59.5986H347.715L337.6 76.9969V174.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.523 141.337H362.545C362.913 141.337 363.212 141.038 363.212 140.669V137.149C363.212 136.78 362.913 136.48 362.545 136.48H359.523C359.154 136.48 358.855 136.78 358.855 137.149V140.669C358.855 141.038 359.154 141.337 359.523 141.337",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.783 141.337H355.804C356.173 141.337 356.472 141.038 356.472 140.669V137.149C356.472 136.78 356.173 136.48 355.804 136.48H352.783C352.413 136.48 352.115 136.78 352.115 137.149V140.669C352.115 141.038 352.413 141.337 352.783 141.337",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.042 141.337H349.064C349.432 141.337 349.732 141.038 349.732 140.669V137.149C349.732 136.78 349.432 136.48 349.064 136.48H346.042C345.673 136.48 345.374 136.78 345.374 137.149V140.669C345.374 141.038 345.673 141.337 346.042 141.337",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.523 131.674H362.545C362.913 131.674 363.212 131.376 363.212 131.006V127.486C363.212 127.118 362.913 126.818 362.545 126.818H359.523C359.154 126.818 358.855 127.118 358.855 127.486V131.006C358.855 131.376 359.154 131.674 359.523 131.674",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.783 131.674H355.804C356.173 131.674 356.472 131.376 356.472 131.006V127.486C356.472 127.118 356.173 126.818 355.804 126.818H352.783C352.413 126.818 352.115 127.118 352.115 127.486V131.006C352.115 131.376 352.413 131.674 352.783 131.674",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.042 131.674H349.064C349.432 131.674 349.732 131.376 349.732 131.006V127.486C349.732 127.118 349.432 126.818 349.064 126.818H346.042C345.673 126.818 345.374 127.118 345.374 127.486V131.006C345.374 131.376 345.673 131.674 346.042 131.674",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.523 122.013H362.545C362.913 122.013 363.212 121.715 363.212 121.345V117.825C363.212 117.457 362.913 117.157 362.545 117.157H359.523C359.154 117.157 358.855 117.457 358.855 117.825V121.345C358.855 121.715 359.154 122.013 359.523 122.013",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.783 122.013H355.804C356.173 122.013 356.472 121.715 356.472 121.345V117.825C356.472 117.457 356.173 117.157 355.804 117.157H352.783C352.413 117.157 352.115 117.457 352.115 117.825V121.345C352.115 121.715 352.413 122.013 352.783 122.013",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.042 122.013H349.064C349.432 122.013 349.732 121.715 349.732 121.345V117.825C349.732 117.457 349.432 117.157 349.064 117.157H346.042C345.673 117.157 345.374 117.457 345.374 117.825V121.345C345.374 121.715 345.673 122.013 346.042 122.013",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.523 112.352H362.545C362.913 112.352 363.212 112.053 363.212 111.684V108.164C363.212 107.796 362.913 107.496 362.545 107.496H359.523C359.154 107.496 358.855 107.796 358.855 108.164V111.684C358.855 112.053 359.154 112.352 359.523 112.352",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.783 112.352H355.804C356.173 112.352 356.472 112.053 356.472 111.684V108.164C356.472 107.796 356.173 107.496 355.804 107.496H352.783C352.413 107.496 352.115 107.796 352.115 108.164V111.684C352.115 112.053 352.413 112.352 352.783 112.352",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.042 112.352H349.064C349.432 112.352 349.732 112.053 349.732 111.684V108.164C349.732 107.796 349.432 107.496 349.064 107.496H346.042C345.673 107.496 345.374 107.796 345.374 108.164V111.684C345.374 112.053 345.673 112.352 346.042 112.352",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.523 102.691H362.545C362.913 102.691 363.212 102.392 363.212 102.023V98.5031C363.212 98.1347 362.913 97.8359 362.545 97.8359H359.523C359.154 97.8359 358.855 98.1347 358.855 98.5031V102.023C358.855 102.392 359.154 102.691 359.523 102.691",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.783 102.691H355.804C356.173 102.691 356.472 102.392 356.472 102.023V98.5031C356.472 98.1347 356.173 97.8359 355.804 97.8359H352.783C352.413 97.8359 352.115 98.1347 352.115 98.5031V102.023C352.115 102.392 352.413 102.691 352.783 102.691",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.042 102.691H349.064C349.432 102.691 349.732 102.392 349.732 102.023V98.5031C349.732 98.1347 349.432 97.8359 349.064 97.8359H346.042C345.673 97.8359 345.374 98.1347 345.374 98.5031V102.023C345.374 102.392 345.673 102.691 346.042 102.691",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.523 93.03H362.545C362.913 93.03 363.212 92.7312 363.212 92.3619V88.842C363.212 88.4735 362.913 88.1748 362.545 88.1748H359.523C359.154 88.1748 358.855 88.4735 358.855 88.842V92.3619C358.855 92.7312 359.154 93.03 359.523 93.03",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.783 93.03H355.804C356.173 93.03 356.472 92.7312 356.472 92.3619V88.842C356.472 88.4735 356.173 88.1748 355.804 88.1748H352.783C352.413 88.1748 352.115 88.4735 352.115 88.842V92.3619C352.115 92.7312 352.413 93.03 352.783 93.03",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.042 93.03H349.064C349.432 93.03 349.732 92.7312 349.732 92.3619V88.842C349.732 88.4735 349.432 88.1748 349.064 88.1748H346.042C345.673 88.1748 345.374 88.4735 345.374 88.842V92.3619C345.374 92.7312 345.673 93.03 346.042 93.03",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.164 174.423H368.107C368.476 174.423 368.775 174.124 368.775 173.755V77.1554C368.775 77.0513 368.751 76.9482 368.703 76.8547L360.181 59.9661C360.067 59.7408 359.837 59.5986 359.585 59.5986H345.995C345.757 59.5986 345.537 59.7256 345.417 59.9308L335.586 76.8414C335.527 76.9435 335.496 77.059 335.496 77.1764V173.755C335.496 174.124 335.794 174.423 336.164 174.423Z",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.689 77.3515L365.039 76.9563C365.549 76.9563 365.87 76.4094 365.623 75.9647L358.316 62.784C358.199 62.5712 357.975 62.4395 357.732 62.4395H349.088C348.826 62.4395 348.589 62.5922 348.48 62.8298L341.081 76.4056C340.88 76.8485 341.203 77.3515 341.689 77.3515",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.413 71.2613H401.675C401.305 71.2613 401.007 70.9625 401.007 70.5932V56.0333C401.007 55.6649 401.305 55.3652 401.675 55.3652H404.413C404.782 55.3652 405.081 55.6649 405.081 56.0333V70.5932C405.081 70.9625 404.782 71.2613 404.413 71.2613",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.877 106.074H406.8C406.248 106.074 405.801 105.626 405.801 105.075V71.5462C405.801 70.9945 406.248 70.5469 406.8 70.5469H408.877C409.428 70.5469 409.875 70.9945 409.875 71.5462V105.075C409.875 105.626 409.428 106.074 408.877 106.074",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.491 141.232H413.414C412.862 141.232 412.415 140.785 412.415 140.233V106.704C412.415 106.153 412.862 105.706 413.414 105.706H415.491C416.043 105.706 416.489 106.153 416.489 106.704V140.233C416.489 140.785 416.043 141.232 415.491 141.232",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 417,
    y: 140,
    width: 5,
    height: 45
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.808 140.931H421.883V184.097H417.808V140.931Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.782 184.097H418.91C418.302 184.097 417.808 183.604 417.808 182.996V142.031C417.808 141.424 418.302 140.931 418.91 140.931H420.782C421.39 140.931 421.884 141.424 421.884 142.031V182.996C421.884 183.604 421.39 184.097 420.782 184.097",
    fill: "#0A2A49"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.983 140.86C412.352 140.86 412.651 140.562 412.651 140.192V105.712H406.014C406.382 105.712 406.682 105.412 406.682 105.044V70.5649H401.712C402.08 70.5649 402.38 70.2652 402.38 69.8958V55.3389H384.592V69.8958C384.592 70.2652 384.892 70.5649 385.261 70.5649H380.313V105.044C380.313 105.412 380.094 106.229 380.464 106.229H372.541L373.058 140.192C373.058 140.562 373.357 141.577 373.726 141.577H366.711V184.058H418.685V140.86H411.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.289 44.7471V55.3136H396.705V44.7471",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.28 45.0561V34.8714C395.28 34.502 394.981 34.2033 394.612 34.2033H394.156C394.412 34.1097 394.597 33.8692 394.597 33.581V23.6816H392.396V33.581C392.396 33.8692 392.581 34.1097 392.837 34.2033H392.382C392.014 34.2033 391.714 34.502 391.714 34.8714V45.0561",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.693 24.2629V15.9756",
    stroke: "#0A2A49",
    strokeWidth: 0.984016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.698 184.729H411.762C412.131 184.729 412.43 184.431 412.43 184.061V167.964C412.43 167.595 412.131 167.295 411.762 167.295H408.698C408.329 167.295 408.03 167.595 408.03 167.964V184.061C408.03 184.431 408.329 184.729 408.698 184.729",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.269 184.729H404.333C404.702 184.729 405.001 184.431 405.001 184.061V167.964C405.001 167.595 404.702 167.295 404.333 167.295H401.269C400.9 167.295 400.601 167.595 400.601 167.964V184.061C400.601 184.431 400.9 184.729 401.269 184.729",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.84 184.729H396.903C397.273 184.729 397.572 184.431 397.572 184.061V167.964C397.572 167.595 397.273 167.295 396.903 167.295H393.84C393.471 167.295 393.172 167.595 393.172 167.964V184.061C393.172 184.431 393.471 184.729 393.84 184.729",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 15,
    width: 356,
    height: 278
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.802 292.019H421.883V15.4834H66.802V292.019Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.743 184.729H390.143V167.295H385.743V184.729Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.981 184.729H382.044C382.413 184.729 382.713 184.431 382.713 184.061V167.964C382.713 167.595 382.413 167.295 382.044 167.295H378.981C378.612 167.295 378.313 167.595 378.313 167.964V184.061C378.313 184.431 378.612 184.729 378.981 184.729",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.552 184.729H374.615C374.984 184.729 375.283 184.431 375.283 184.061V167.964C375.283 167.595 374.984 167.295 374.615 167.295H371.552C371.182 167.295 370.884 167.595 370.884 167.964V184.061C370.884 184.431 371.182 184.729 371.552 184.729",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.698 161.142H411.762C412.131 161.142 412.43 160.843 412.43 160.474V157.236C412.43 156.868 412.131 156.568 411.762 156.568H408.698C408.329 156.568 408.03 156.868 408.03 157.236V160.474C408.03 160.843 408.329 161.142 408.698 161.142",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.269 161.142H405.001V156.568H400.601V160.474C400.601 160.843 400.9 161.142 401.269 161.142",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.84 161.142H397.572V156.568H393.172V160.474C393.172 160.843 393.471 161.142 393.84 161.142",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.411 161.142H389.474C389.843 161.142 390.143 160.843 390.143 160.474V157.236C390.143 156.868 389.843 156.568 389.474 156.568H386.411C386.041 156.568 385.743 156.868 385.743 157.236V160.474C385.743 160.843 386.041 161.142 386.411 161.142",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.981 161.142H382.044C382.413 161.142 382.713 160.843 382.713 160.474V157.236C382.713 156.868 382.413 156.568 382.044 156.568H378.981C378.612 156.568 378.313 156.868 378.313 157.236V160.474C378.313 160.843 378.612 161.142 378.981 161.142",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.552 161.142H374.615C374.984 161.142 375.283 160.843 375.283 160.474V157.236C375.283 156.868 374.984 156.568 374.615 156.568H371.552C371.182 156.568 370.884 156.868 370.884 157.236V160.474C370.884 160.843 371.182 161.142 371.552 161.142",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.698 151.953H411.762C412.131 151.953 412.43 151.654 412.43 151.284V148.048C412.43 147.679 412.131 147.379 411.762 147.379H408.698C408.329 147.379 408.03 147.679 408.03 148.048V151.284C408.03 151.654 408.329 151.953 408.698 151.953",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.269 151.953H404.333C404.702 151.953 405.001 151.654 405.001 151.284V148.048C405.001 147.679 404.702 147.379 404.333 147.379H401.269C400.9 147.379 400.601 147.679 400.601 148.048V151.284C400.601 151.654 400.9 151.953 401.269 151.953",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.84 151.953H396.903C397.273 151.953 397.572 151.654 397.572 151.284V148.048C397.572 147.679 397.273 147.379 396.903 147.379H393.84C393.471 147.379 393.172 147.679 393.172 148.048V151.284C393.172 151.654 393.471 151.953 393.84 151.953",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.411 151.953H389.474C389.843 151.953 390.143 151.654 390.143 151.284V148.048C390.143 147.679 389.843 147.379 389.474 147.379H386.411C386.041 147.379 385.743 147.679 385.743 148.048V151.284C385.743 151.654 386.041 151.953 386.411 151.953",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.981 151.953H382.044C382.413 151.953 382.713 151.654 382.713 151.284V148.048C382.713 147.679 382.413 147.379 382.044 147.379H378.981C378.612 147.379 378.313 147.679 378.313 148.048V151.284C378.313 151.654 378.612 151.953 378.981 151.953",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.552 151.953H374.615C374.984 151.953 375.283 151.654 375.283 151.284V148.048C375.283 147.679 374.984 147.379 374.615 147.379H371.552C371.182 147.379 370.884 147.679 370.884 148.048V151.284C370.884 151.654 371.182 151.953 371.552 151.953",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.269 137.474H404.333C404.702 137.474 405.001 137.175 405.001 136.806V133.569C405.001 133.2 404.702 132.9 404.333 132.9H401.269C400.9 132.9 400.601 133.2 400.601 133.569V136.806C400.601 137.175 400.9 137.474 401.269 137.474",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.84 137.474H396.903C397.273 137.474 397.572 137.175 397.572 136.806V133.569C397.572 133.2 397.273 132.9 396.903 132.9H393.84C393.471 132.9 393.172 133.2 393.172 133.569V136.806C393.172 137.175 393.471 137.474 393.84 137.474",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.411 137.474H389.474C389.843 137.474 390.143 137.175 390.143 136.806V133.569C390.143 133.2 389.843 132.9 389.474 132.9H386.411C386.041 132.9 385.743 133.2 385.743 133.569V136.806C385.743 137.175 386.041 137.474 386.411 137.474",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.981 137.474H382.044C382.413 137.474 382.713 137.175 382.713 136.806V133.569C382.713 133.2 382.413 132.9 382.044 132.9H378.981C378.612 132.9 378.313 133.2 378.313 133.569V136.806C378.313 137.175 378.612 137.474 378.981 137.474",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.269 126.934H404.333C404.702 126.934 405.001 126.635 405.001 126.266V123.028C405.001 122.659 404.702 122.36 404.333 122.36H401.269C400.9 122.36 400.601 122.659 400.601 123.028V126.266C400.601 126.635 400.9 126.934 401.269 126.934",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.84 126.934H396.903C397.273 126.934 397.572 126.635 397.572 126.266V123.028C397.572 122.659 397.273 122.36 396.903 122.36H393.84C393.471 122.36 393.172 122.659 393.172 123.028V126.266C393.172 126.635 393.471 126.934 393.84 126.934",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.411 126.934H389.474C389.843 126.934 390.143 126.635 390.143 126.266V123.028C390.143 122.659 389.843 122.36 389.474 122.36H386.411C386.041 122.36 385.743 122.659 385.743 123.028V126.266C385.743 126.635 386.041 126.934 386.411 126.934",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.981 126.934H382.044C382.413 126.934 382.713 126.635 382.713 126.266V123.028C382.713 122.659 382.413 122.36 382.044 122.36H378.981C378.612 122.36 378.313 122.659 378.313 123.028V126.266C378.313 126.635 378.612 126.934 378.981 126.934",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.269 116.554H404.333C404.702 116.554 405.001 116.255 405.001 115.886V112.649C405.001 112.28 404.702 111.98 404.333 111.98H401.269C400.9 111.98 400.601 112.28 400.601 112.649V115.886C400.601 116.255 400.9 116.554 401.269 116.554",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.84 116.554H396.903C397.273 116.554 397.572 116.255 397.572 115.886V112.649C397.572 112.28 397.273 111.98 396.903 111.98H393.84C393.471 111.98 393.172 112.28 393.172 112.649V115.886C393.172 116.255 393.471 116.554 393.84 116.554",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.743 116.554H390.143V111.98H385.743V116.554Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.981 116.554H382.044C382.413 116.554 382.713 116.255 382.713 115.886V112.649C382.713 112.28 382.413 111.98 382.044 111.98H378.981C378.612 111.98 378.313 112.28 378.313 112.649V115.886C378.313 116.255 378.612 116.554 378.981 116.554",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.948 105.715V71.9044C404.948 71.5351 404.649 71.2363 404.28 71.2363H379.247C378.879 71.2363 378.58 71.5351 378.58 71.9044V105.715C378.58 106.083 378.879 106.383 379.247 106.383H404.28C404.649 106.383 404.948 106.083 404.948 105.715Z",
    stroke: "#0A2A49",
    strokeWidth: 0.984016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.951 142.199V184.061C416.951 184.43 416.653 184.729 416.283 184.729H367.244C366.875 184.729 366.576 184.43 366.576 184.061V142.199C366.576 141.83 366.875 141.531 367.244 141.531H416.283C416.653 141.531 416.951 141.83 416.951 142.199Z",
    stroke: "#0A2A49",
    strokeWidth: 0.984016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.859 70.5677V56.6779C382.859 56.3085 383.152 56.0098 383.521 56.0098H399.985C400.354 56.0098 400.646 56.3085 400.646 56.6779V70.5677C400.646 70.9361 400.347 71.2358 399.979 71.2358H383.527C383.158 71.2358 382.859 70.9361 382.859 70.5677Z",
    stroke: "#0A2A49",
    strokeWidth: 0.984016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.972 46.087V55.3173C394.972 55.6867 394.673 55.9854 394.303 55.9854H389.224C388.855 55.9854 388.556 55.6867 388.556 55.3173V46.087C388.556 45.7177 388.855 45.4189 389.224 45.4189H394.303C394.673 45.4189 394.972 45.7177 394.972 46.087Z",
    stroke: "#0A2A49",
    strokeWidth: 0.984016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.879 45.4405H390.649C390.28 45.4405 389.981 45.1418 389.981 44.7724V35.5421C389.981 35.1728 390.28 34.874 390.649 34.874H392.879C393.247 34.874 393.547 35.1728 393.547 35.5421V44.7724C393.547 45.1418 393.247 45.4405 392.879 45.4405Z",
    stroke: "#0A2A49",
    strokeWidth: 0.984016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.196 34.92H391.331C390.962 34.92 390.664 34.6213 390.664 34.2519V25.0216C390.664 24.6523 390.962 24.3535 391.331 24.3535H392.196C392.565 24.3535 392.864 24.6523 392.864 25.0216V34.2519C392.864 34.6213 392.565 34.92 392.196 34.92Z",
    stroke: "#0A2A49",
    strokeWidth: 0.984016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.562 141.532H410.87",
    stroke: "#0A2A49",
    strokeWidth: 0.984016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.445 106.136H400.509C400.877 106.136 401.177 105.837 401.177 105.468V91.5206C401.177 91.1513 400.877 90.8525 400.509 90.8525H397.445C397.076 90.8525 396.777 91.1513 396.777 91.5206V105.468C396.777 105.837 397.076 106.136 397.445 106.136",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.016 106.136H393.079C393.449 106.136 393.748 105.837 393.748 105.468V91.5206C393.748 91.1513 393.449 90.8525 393.079 90.8525H390.016C389.646 90.8525 389.348 91.1513 389.348 91.5206V105.468C389.348 105.837 389.646 106.136 390.016 106.136",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.587 106.136H385.65C386.02 106.136 386.318 105.837 386.318 105.468V91.5206C386.318 91.1513 386.02 90.8525 385.65 90.8525H382.587C382.217 90.8525 381.918 91.1513 381.918 91.5206V105.468C381.918 105.837 382.217 106.136 382.587 106.136",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.312 87.8725H400.376C400.745 87.8725 401.044 87.5737 401.044 87.2044V83.9679C401.044 83.5985 400.745 83.2988 400.376 83.2988H397.312C396.943 83.2988 396.644 83.5985 396.644 83.9679V87.2044C396.644 87.5737 396.943 87.8725 397.312 87.8725",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.882 87.8725H392.946C393.316 87.8725 393.614 87.5737 393.614 87.2044V83.9679C393.614 83.5985 393.316 83.2988 392.946 83.2988H389.882C389.513 83.2988 389.214 83.5985 389.214 83.9679V87.2044C389.214 87.5737 389.513 87.8725 389.882 87.8725",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.453 87.8725H385.517C385.886 87.8725 386.185 87.5737 386.185 87.2044V83.9679C386.185 83.5985 385.886 83.2988 385.517 83.2988H382.453C382.085 83.2988 381.785 83.5985 381.785 83.9679V87.2044C381.785 87.5737 382.085 87.8725 382.453 87.8725",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.312 80.4144H400.376C400.745 80.4144 401.044 80.1157 401.044 79.7463V76.5099C401.044 76.1405 400.745 75.8408 400.376 75.8408H397.312C396.943 75.8408 396.644 76.1405 396.644 76.5099V79.7463C396.644 80.1157 396.943 80.4144 397.312 80.4144",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.882 80.4144H392.946C393.316 80.4144 393.614 80.1157 393.614 79.7463V76.5099C393.614 76.1405 393.316 75.8408 392.946 75.8408H389.882C389.513 75.8408 389.214 76.1405 389.214 76.5099V79.7463C389.214 80.1157 389.513 80.4144 389.882 80.4144",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.453 80.4144H385.517C385.886 80.4144 386.185 80.1157 386.185 79.7463V76.5099C386.185 76.1405 385.886 75.8408 385.517 75.8408H382.453C382.085 75.8408 381.785 76.1405 381.785 76.5099V79.7463C381.785 80.1157 382.085 80.4144 382.453 80.4144",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.878 66.1644H396.942C397.311 66.1644 397.61 65.8657 397.61 65.4963V62.2599C397.61 61.8905 397.311 61.5908 396.942 61.5908H393.878C393.508 61.5908 393.21 61.8905 393.21 62.2599V65.4963C393.21 65.8657 393.508 66.1644 393.878 66.1644",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.448 66.1644H389.512C389.881 66.1644 390.18 65.8657 390.18 65.4963V62.2599C390.18 61.8905 389.881 61.5908 389.512 61.5908H386.448C386.08 61.5908 385.78 61.8905 385.78 62.2599V65.4963C385.78 65.8657 386.08 66.1644 386.448 66.1644",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.61 140.863V107.051C372.61 106.682 372.908 106.383 373.278 106.383H410.249C410.619 106.383 410.918 106.682 410.918 107.051V140.863C410.918 141.233 410.619 141.532 410.249 141.532H373.278C372.908 141.532 372.61 141.233 372.61 140.863Z",
    stroke: "#0A2A49",
    strokeWidth: 0.984016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.315 64.1256L316.189 49.4875C315.917 49.1296 315.377 49.1372 315.114 49.5018L302.599 66.9287C302.518 67.0423 302.474 67.1788 302.474 67.3181V72.055V161.736C302.474 162.104 302.773 162.404 303.142 162.404H327.718H328.911C329.279 162.404 329.579 162.104 329.579 161.736V72.2239C329.579 69.0103 328.735 65.9943 327.315 64.1256",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 67.1031V175.103H325.507V77.011C325.507 70.6631 324.146 64.5729 321.719 60.0623L315.642 48.7676L302.474 67.1031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 77.1631V80.412C306.178 80.6782 310.033 80.8214 313.992 80.8214C319.423 80.8214 320.68 81.0209 325.598 80.5208V77.2719C320.68 77.7777 319.423 77.5792 313.992 77.5792C310.033 77.5792 306.178 77.4351 302.474 77.1631",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 86.7178V89.9657C306.178 90.2329 310.033 90.3761 313.992 90.3761C319.423 90.3761 320.523 90.6472 325.439 90.1461V86.8972C320.523 87.4031 319.423 87.133 313.992 87.133C310.033 87.133 306.178 86.9888 302.474 86.7178",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 96.2717V99.5206C306.178 99.7869 310.033 99.9301 313.992 99.9301C319.423 99.9301 320.68 99.8642 325.598 99.3631V96.1143C320.68 96.6201 319.423 96.6869 313.992 96.6869C310.033 96.6869 306.178 96.5438 302.474 96.2717",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 105.825V109.074C306.178 109.34 310.033 109.483 313.992 109.483C319.423 109.483 320.68 109.488 325.598 108.987V105.739C320.68 106.245 319.423 106.24 313.992 106.24C310.033 106.24 306.178 106.097 302.474 105.825",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 115.38V118.629C306.178 118.895 310.033 119.038 313.992 119.038C319.423 119.038 320.838 119.207 325.755 118.706V115.458C320.838 115.964 319.423 115.795 313.992 115.795C310.033 115.795 306.178 115.652 302.474 115.38",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 124.934V128.182C306.178 128.449 310.033 128.592 313.992 128.592C319.423 128.592 320.838 128.832 325.755 128.332V125.083C320.838 125.589 319.423 125.35 313.992 125.35C310.033 125.35 306.178 125.206 302.474 124.934",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 134.487V137.736C306.178 138.002 310.033 138.146 313.992 138.146C319.423 138.146 320.523 138.299 325.439 137.799V134.55C320.523 135.056 319.423 134.903 313.992 134.903C310.033 134.903 306.178 134.759 302.474 134.487",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 144.042V147.29C306.178 147.557 310.033 147.7 313.992 147.7C319.423 147.7 320.68 147.925 325.598 147.424V144.176C320.68 144.681 319.423 144.457 313.992 144.457C310.033 144.457 306.178 144.313 302.474 144.042",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.474 153.597V156.845C306.178 157.112 310.033 157.255 313.992 157.255C319.423 157.255 320.838 157.393 325.755 156.893V153.644C320.838 154.15 319.423 154.012 313.992 154.012C310.033 154.012 306.178 153.868 302.474 153.597",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.79 67.3184V175.104H323.824V77.0115C323.824 70.6636 322.463 64.5734 320.035 60.0628L314.466 49.7101C314.232 49.2749 313.623 49.2357 313.335 49.6366L300.915 66.929C300.834 67.0425 300.79 67.179 300.79 67.3184Z",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.193 184.21H347.408C347.777 184.21 348.076 183.911 348.076 183.542V88.8517C348.076 88.4823 347.777 88.1836 347.408 88.1836H325.193C324.824 88.1836 324.524 88.4823 324.524 88.8517V183.542C324.524 183.911 324.824 184.21 325.193 184.21",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 15,
    width: 356,
    height: 278
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.802 292.019H421.883V15.4834H66.802V292.019Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.19 184.21H343.74V88.1836H320.19V184.21Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.774 184.21H343.74V88.1836H317.774V184.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.507 184.499H341.057V88.4727H317.507V184.499Z",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.589 142.479H338.157C338.526 142.479 338.825 142.18 338.825 141.811V138.796C338.825 138.428 338.526 138.128 338.157 138.128H335.589C335.22 138.128 334.921 138.428 334.921 138.796V141.811C334.921 142.18 335.22 142.479 335.589 142.479",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.55 142.479H332.117C332.487 142.479 332.786 142.18 332.786 141.811V138.796C332.786 138.428 332.487 138.128 332.117 138.128H329.55C329.181 138.128 328.882 138.428 328.882 138.796V141.811C328.882 142.18 329.181 142.479 329.55 142.479",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.511 142.479H326.078C326.447 142.479 326.747 142.18 326.747 141.811V138.796C326.747 138.428 326.447 138.128 326.078 138.128H323.511C323.141 138.128 322.843 138.428 322.843 138.796V141.811C322.843 142.18 323.141 142.479 323.511 142.479",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.589 133.822H338.157C338.526 133.822 338.825 133.523 338.825 133.154V130.139C338.825 129.77 338.526 129.471 338.157 129.471H335.589C335.22 129.471 334.921 129.77 334.921 130.139V133.154C334.921 133.523 335.22 133.822 335.589 133.822",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.55 133.822H332.117C332.487 133.822 332.786 133.523 332.786 133.154V130.139C332.786 129.77 332.487 129.471 332.117 129.471H329.55C329.181 129.471 328.882 129.77 328.882 130.139V133.154C328.882 133.523 329.181 133.822 329.55 133.822",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.511 133.822H326.078C326.447 133.822 326.747 133.523 326.747 133.154V130.139C326.747 129.77 326.447 129.471 326.078 129.471H323.511C323.141 129.471 322.843 129.77 322.843 130.139V133.154C322.843 133.523 323.141 133.822 323.511 133.822",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.589 125.166H338.157C338.526 125.166 338.825 124.867 338.825 124.498V121.483C338.825 121.114 338.526 120.814 338.157 120.814H335.589C335.22 120.814 334.921 121.114 334.921 121.483V124.498C334.921 124.867 335.22 125.166 335.589 125.166",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.55 125.166H332.117C332.487 125.166 332.786 124.867 332.786 124.498V121.483C332.786 121.114 332.487 120.814 332.117 120.814H329.55C329.181 120.814 328.882 121.114 328.882 121.483V124.498C328.882 124.867 329.181 125.166 329.55 125.166",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.511 125.166H326.078C326.447 125.166 326.747 124.867 326.747 124.498V121.483C326.747 121.114 326.447 120.814 326.078 120.814H323.511C323.141 120.814 322.843 121.114 322.843 121.483V124.498C322.843 124.867 323.141 125.166 323.511 125.166",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.589 168.093H338.157C338.526 168.093 338.825 167.795 338.825 167.425V164.41C338.825 164.042 338.526 163.742 338.157 163.742H335.589C335.22 163.742 334.921 164.042 334.921 164.41V167.425C334.921 167.795 335.22 168.093 335.589 168.093",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.55 168.093H332.117C332.487 168.093 332.786 167.795 332.786 167.425V164.41C332.786 164.042 332.487 163.742 332.117 163.742H329.55C329.181 163.742 328.882 164.042 328.882 164.41V167.425C328.882 167.795 329.181 168.093 329.55 168.093",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.511 168.093H326.078C326.447 168.093 326.747 167.795 326.747 167.425V164.41C326.747 164.042 326.447 163.742 326.078 163.742H323.511C323.141 163.742 322.843 164.042 322.843 164.41V167.425C322.843 167.795 323.141 168.093 323.511 168.093",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.589 159.437H338.157C338.526 159.437 338.825 159.138 338.825 158.769V155.754C338.825 155.385 338.526 155.086 338.157 155.086H335.589C335.22 155.086 334.921 155.385 334.921 155.754V158.769C334.921 159.138 335.22 159.437 335.589 159.437",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.882 159.437H332.786V155.086H328.882V159.437Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.511 159.437H326.078C326.447 159.437 326.747 159.138 326.747 158.769V155.754C326.747 155.385 326.447 155.086 326.078 155.086H323.511C323.141 155.086 322.843 155.385 322.843 155.754V158.769C322.843 159.138 323.141 159.437 323.511 159.437",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.589 150.781H338.157C338.526 150.781 338.825 150.482 338.825 150.113V147.098C338.825 146.728 338.526 146.43 338.157 146.43H335.589C335.22 146.43 334.921 146.728 334.921 147.098V150.113C334.921 150.482 335.22 150.781 335.589 150.781",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.55 150.781H332.117C332.487 150.781 332.786 150.482 332.786 150.113V147.098C332.786 146.728 332.487 146.43 332.117 146.43H329.55C329.181 146.43 328.882 146.728 328.882 147.098V150.113C328.882 150.482 329.181 150.781 329.55 150.781",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.511 150.781H326.078C326.447 150.781 326.747 150.482 326.747 150.113V147.098C326.747 146.728 326.447 146.43 326.078 146.43H323.511C323.141 146.43 322.843 146.728 322.843 147.098V150.113C322.843 150.482 323.141 150.781 323.511 150.781",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.589 116.509H338.157C338.526 116.509 338.825 116.211 338.825 115.841V112.826C338.825 112.458 338.526 112.158 338.157 112.158H335.589C335.22 112.158 334.921 112.458 334.921 112.826V115.841C334.921 116.211 335.22 116.509 335.589 116.509",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.55 116.509H332.117C332.487 116.509 332.786 116.211 332.786 115.841V112.826C332.786 112.458 332.487 112.158 332.117 112.158H329.55C329.181 112.158 328.882 112.458 328.882 112.826V115.841C328.882 116.211 329.181 116.509 329.55 116.509",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.511 116.509H326.078C326.447 116.509 326.747 116.211 326.747 115.841V112.826C326.747 112.458 326.447 112.158 326.078 112.158H323.511C323.141 112.158 322.843 112.458 322.843 112.826V115.841C322.843 116.211 323.141 116.509 323.511 116.509",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.589 107.853H338.157C338.526 107.853 338.825 107.554 338.825 107.185V104.17C338.825 103.802 338.526 103.502 338.157 103.502H335.589C335.22 103.502 334.921 103.802 334.921 104.17V107.185C334.921 107.554 335.22 107.853 335.589 107.853",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.55 107.853H332.117C332.487 107.853 332.786 107.554 332.786 107.185V104.17C332.786 103.802 332.487 103.502 332.117 103.502H329.55C329.181 103.502 328.882 103.802 328.882 104.17V107.185C328.882 107.554 329.181 107.853 329.55 107.853",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.511 107.853H326.078C326.447 107.853 326.747 107.554 326.747 107.185V104.17C326.747 103.802 326.447 103.502 326.078 103.502H323.511C323.141 103.502 322.843 103.802 322.843 104.17V107.185C322.843 107.554 323.141 107.853 323.511 107.853",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.921 99.196H338.826V94.8447H334.921V99.196Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.55 99.196H332.117C332.487 99.196 332.786 98.8972 332.786 98.5279V95.5128C332.786 95.1444 332.487 94.8447 332.117 94.8447H329.55C329.181 94.8447 328.882 95.1444 328.882 95.5128V98.5279C328.882 98.8972 329.181 99.196 329.55 99.196",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.511 99.196H326.078C326.447 99.196 326.747 98.8972 326.747 98.5279V95.5128C326.747 95.1444 326.447 94.8447 326.078 94.8447H323.511C323.141 94.8447 322.843 95.1444 322.843 95.5128V98.5279C322.843 98.8972 323.141 99.196 323.511 99.196",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.932 175.953H302.148C302.516 175.953 302.816 175.654 302.816 175.285V97.2199C302.816 96.8505 302.516 96.5518 302.148 96.5518H279.932C279.563 96.5518 279.264 96.8505 279.264 97.2199V175.285C279.264 175.654 279.563 175.953 279.932 175.953",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 15,
    width: 356,
    height: 278
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.802 292.019H421.883V15.4834H66.802V292.019Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.929 175.953H298.48V96.5518H274.929V175.953Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.929 175.953H298.48V96.5518H274.929V175.953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.072 176.374H295.286C295.656 176.374 295.956 176.075 295.956 175.705V97.6408C295.956 97.2714 295.656 96.9727 295.286 96.9727H273.072C272.703 96.9727 272.404 97.2714 272.404 97.6408V175.705C272.404 176.075 272.703 176.374 273.072 176.374Z",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.66 150.847H293.565V146.496H289.66V150.847Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.289 150.847H286.857C287.226 150.847 287.526 150.549 287.526 150.179V147.164C287.526 146.796 287.226 146.496 286.857 146.496H284.289C283.92 146.496 283.621 146.796 283.621 147.164V150.179C283.621 150.549 283.92 150.847 284.289 150.847",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.25 150.847H280.818C281.187 150.847 281.486 150.549 281.486 150.179V147.164C281.486 146.796 281.187 146.496 280.818 146.496H278.25C277.881 146.496 277.582 146.796 277.582 147.164V150.179C277.582 150.549 277.881 150.847 278.25 150.847",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.329 142.19H292.896C293.266 142.19 293.565 141.891 293.565 141.522V138.507C293.565 138.139 293.266 137.839 292.896 137.839H290.329C289.959 137.839 289.661 138.139 289.661 138.507V141.522C289.661 141.891 289.959 142.19 290.329 142.19",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.289 142.19H286.857C287.226 142.19 287.526 141.891 287.526 141.522V138.507C287.526 138.139 287.226 137.839 286.857 137.839H284.289C283.92 137.839 283.621 138.139 283.621 138.507V141.522C283.621 141.891 283.92 142.19 284.289 142.19",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.25 142.19H280.818C281.187 142.19 281.486 141.891 281.486 141.522V138.507C281.486 138.139 281.187 137.839 280.818 137.839H278.25C277.881 137.839 277.582 138.139 277.582 138.507V141.522C277.582 141.891 277.881 142.19 278.25 142.19",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.329 168.317H292.896C293.266 168.317 293.565 168.018 293.565 167.649V164.634C293.565 164.265 293.266 163.966 292.896 163.966H290.329C289.959 163.966 289.661 164.265 289.661 164.634V167.649C289.661 168.018 289.959 168.317 290.329 168.317",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.289 168.317H286.857C287.226 168.317 287.526 168.018 287.526 167.649V164.634C287.526 164.265 287.226 163.966 286.857 163.966H284.289C283.92 163.966 283.621 164.265 283.621 164.634V167.649C283.621 168.018 283.92 168.317 284.289 168.317",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.25 168.317H280.818C281.187 168.317 281.486 168.018 281.486 167.649V164.634C281.486 164.265 281.187 163.966 280.818 163.966H278.25C277.881 163.966 277.582 164.265 277.582 164.634V167.649C277.582 168.018 277.881 168.317 278.25 168.317",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.329 159.661H292.896C293.266 159.661 293.565 159.362 293.565 158.993V155.978C293.565 155.608 293.266 155.31 292.896 155.31H290.329C289.959 155.31 289.661 155.608 289.661 155.978V158.993C289.661 159.362 289.959 159.661 290.329 159.661",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.289 159.661H286.857C287.226 159.661 287.526 159.362 287.526 158.993V155.978C287.526 155.608 287.226 155.31 286.857 155.31H284.289C283.92 155.31 283.621 155.608 283.621 155.978V158.993C283.621 159.362 283.92 159.661 284.289 159.661",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.582 159.661H281.486V155.31H277.582V159.661Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.329 133.534H292.896C293.266 133.534 293.565 133.235 293.565 132.866V129.851C293.565 129.482 293.266 129.183 292.896 129.183H290.329C289.959 129.183 289.661 129.482 289.661 129.851V132.866C289.661 133.235 289.959 133.534 290.329 133.534",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.289 133.534H286.857C287.226 133.534 287.526 133.235 287.526 132.866V129.851C287.526 129.482 287.226 129.183 286.857 129.183H284.289C283.92 129.183 283.621 129.482 283.621 129.851V132.866C283.621 133.235 283.92 133.534 284.289 133.534",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.25 133.534H280.818C281.187 133.534 281.486 133.235 281.486 132.866V129.851C281.486 129.482 281.187 129.183 280.818 129.183H278.25C277.881 129.183 277.582 129.482 277.582 129.851V132.866C277.582 133.235 277.881 133.534 278.25 133.534",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.329 124.878H292.896C293.266 124.878 293.565 124.579 293.565 124.21V121.194C293.565 120.826 293.266 120.526 292.896 120.526H290.329C289.959 120.526 289.661 120.826 289.661 121.194V124.21C289.661 124.579 289.959 124.878 290.329 124.878",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.289 124.878H286.857C287.226 124.878 287.526 124.579 287.526 124.21V121.194C287.526 120.826 287.226 120.526 286.857 120.526H284.289C283.92 120.526 283.621 120.826 283.621 121.194V124.21C283.621 124.579 283.92 124.878 284.289 124.878",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.25 124.878H280.818C281.187 124.878 281.486 124.579 281.486 124.21V121.194C281.486 120.826 281.187 120.526 280.818 120.526H278.25C277.881 120.526 277.582 120.826 277.582 121.194V124.21C277.582 124.579 277.881 124.878 278.25 124.878",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.329 116.221H292.896C293.266 116.221 293.565 115.923 293.565 115.553V112.538C293.565 112.17 293.266 111.87 292.896 111.87H290.329C289.959 111.87 289.661 112.17 289.661 112.538V115.553C289.661 115.923 289.959 116.221 290.329 116.221",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.289 116.221H286.857C287.226 116.221 287.526 115.923 287.526 115.553V112.538C287.526 112.17 287.226 111.87 286.857 111.87H284.289C283.92 111.87 283.621 112.17 283.621 112.538V115.553C283.621 115.923 283.92 116.221 284.289 116.221",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.25 116.221H280.818C281.187 116.221 281.486 115.923 281.486 115.553V112.538C281.486 112.17 281.187 111.87 280.818 111.87H278.25C277.881 111.87 277.582 112.17 277.582 112.538V115.553C277.582 115.923 277.881 116.221 278.25 116.221",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.329 107.564H292.896C293.266 107.564 293.565 107.265 293.565 106.896V103.881C293.565 103.513 293.266 103.213 292.896 103.213H290.329C289.959 103.213 289.661 103.513 289.661 103.881V106.896C289.661 107.265 289.959 107.564 290.329 107.564",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.289 107.564H286.857C287.226 107.564 287.526 107.265 287.526 106.896V103.881C287.526 103.513 287.226 103.213 286.857 103.213H284.289C283.92 103.213 283.621 103.513 283.621 103.881V106.896C283.621 107.265 283.92 107.564 284.289 107.564",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.25 107.564H280.818C281.187 107.564 281.486 107.265 281.486 106.896V103.881C281.486 103.513 281.187 103.213 280.818 103.213H278.25C277.881 103.213 277.582 103.513 277.582 103.881V106.896C277.582 107.265 277.881 107.564 278.25 107.564",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.98 169.224H191.608C191.977 169.224 192.274 168.927 192.274 168.559V68.8576C192.274 68.4902 191.977 68.1924 191.608 68.1924H167.98C167.613 68.1924 167.314 68.4902 167.314 68.8576V168.559C167.314 168.927 167.613 169.224 167.98 169.224",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 13,
    width: 356,
    height: 277
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 289.784H395.081V13.249H40V289.784Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.119 169.223H188.08V68.0576H163.119V169.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.338 124.998H181.14C181.508 124.998 181.807 124.699 181.807 124.329V121.055C181.807 120.685 181.508 120.386 181.14 120.386H178.338C177.968 120.386 177.669 120.685 177.669 121.055V124.329C177.669 124.699 177.968 124.998 178.338 124.998",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 124.998H175.406V120.386H171.268V124.998Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.868 124.998H169.005V120.386H164.868V124.998Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.338 115.823H181.14C181.508 115.823 181.807 115.524 181.807 115.155V111.88C181.807 111.511 181.508 111.211 181.14 111.211H178.338C177.968 111.211 177.669 111.511 177.669 111.88V115.155C177.669 115.524 177.968 115.823 178.338 115.823",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 115.824H175.406V111.212H171.268V115.824Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.868 115.824H169.005V111.212H164.868V115.824Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.338 106.649H181.14C181.508 106.649 181.807 106.35 181.807 105.981V102.706C181.807 102.337 181.508 102.037 181.14 102.037H178.338C177.968 102.037 177.669 102.337 177.669 102.706V105.981C177.669 106.35 177.968 106.649 178.338 106.649",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 106.649H175.406V102.037H171.268V106.649Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.868 106.649H169.005V102.037H164.868V106.649Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.338 152.144H181.14C181.508 152.144 181.807 151.845 181.807 151.476V148.201C181.807 147.832 181.508 147.533 181.14 147.533H178.338C177.968 147.533 177.669 147.832 177.669 148.201V151.476C177.669 151.845 177.968 152.144 178.338 152.144",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 152.144H175.406V147.533H171.268V152.144Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.868 152.144H169.005V147.533H164.868V152.144Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.338 142.97H181.14C181.508 142.97 181.807 142.671 181.807 142.302V139.027C181.807 138.658 181.508 138.359 181.14 138.359H178.338C177.968 138.359 177.669 138.658 177.669 139.027V142.302C177.669 142.671 177.968 142.97 178.338 142.97",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 142.97H175.406V138.359H171.268V142.97Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.868 142.97H169.005V138.359H164.868V142.97Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.338 133.795H181.14C181.508 133.795 181.807 133.497 181.807 133.127V129.853C181.807 129.483 181.508 129.185 181.14 129.185H178.338C177.968 129.185 177.669 129.483 177.669 129.853V133.127C177.669 133.497 177.968 133.795 178.338 133.795",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 133.795H175.406V129.185H171.268V133.795Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.868 133.795H169.005V129.185H164.868V133.795Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.338 97.4751H181.14C181.508 97.4751 181.807 97.1763 181.807 96.807V93.5323C181.807 93.163 181.508 92.8633 181.14 92.8633H178.338C177.968 92.8633 177.669 93.163 177.669 93.5323V96.807C177.669 97.1763 177.968 97.4751 178.338 97.4751",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 97.4741H175.406V92.8623H171.268V97.4741Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.868 97.4741H169.005V92.8623H164.868V97.4741Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.338 88.3003H181.14C181.508 88.3003 181.807 88.0015 181.807 87.6322V84.3575C181.807 83.9882 181.508 83.6885 181.14 83.6885H178.338C177.968 83.6885 177.669 83.9882 177.669 84.3575V87.6322C177.669 88.0015 177.968 88.3003 178.338 88.3003",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 88.3003H175.406V83.6885H171.268V88.3003Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.536 88.3003H168.338C168.707 88.3003 169.005 88.0015 169.005 87.6322V84.3575C169.005 83.9882 168.707 83.6885 168.338 83.6885H165.536C165.167 83.6885 164.868 83.9882 164.868 84.3575V87.6322C164.868 88.0015 165.167 88.3003 165.536 88.3003",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.338 79.1265H181.14C181.508 79.1265 181.807 78.8277 181.807 78.4583V75.1837C181.807 74.8143 181.508 74.5146 181.14 74.5146H178.338C177.968 74.5146 177.669 74.8143 177.669 75.1837V78.4583C177.669 78.8277 177.968 79.1265 178.338 79.1265",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 79.1255H175.406V74.5137H171.268V79.1255Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.536 79.1265H168.338C168.707 79.1265 169.005 78.8277 169.005 78.4583V75.1837C169.005 74.8143 168.707 74.5146 168.338 74.5146H165.536C165.167 74.5146 164.868 74.8143 164.868 75.1837V78.4583C164.868 78.8277 165.167 79.1265 165.536 79.1265",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.263 170.066H184.887C185.255 170.066 185.555 169.767 185.555 169.398V68.964C185.555 68.5956 185.255 68.2959 184.887 68.2959H161.263C160.894 68.2959 160.594 68.5956 160.594 68.964V169.398C160.594 169.767 160.894 170.066 161.263 170.066Z",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.95 172.475H170.573C170.942 172.475 171.242 172.177 171.242 171.807V88.9933C171.242 88.6239 170.942 88.3252 170.573 88.3252H146.95C146.58 88.3252 146.282 88.6239 146.282 88.9933V171.807C146.282 172.177 146.58 172.475 146.95 172.475",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 13,
    width: 356,
    height: 277
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 289.784H395.081V13.249H40V289.784Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.574 172.475H167.534V88.3252H142.574V172.475Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.574 172.475H167.534V88.3252H142.574V172.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.139 172.213H164.762C165.131 172.213 165.431 171.914 165.431 171.545V88.7306C165.431 88.3612 165.131 88.0625 164.762 88.0625H141.139C140.77 88.0625 140.471 88.3612 140.471 88.7306V171.545C140.471 171.914 140.77 172.213 141.139 172.213Z",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.256 145.868H162.393V141.925C162.393 141.556 162.095 141.257 161.725 141.257H158.256V145.868Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.523 145.868H155.324C155.694 145.868 155.992 145.569 155.992 145.2V141.925C155.992 141.556 155.694 141.257 155.324 141.257H152.523C152.154 141.257 151.855 141.556 151.855 141.925V145.2C151.855 145.569 152.154 145.868 152.523 145.868",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.454 145.868H149.591V141.257H145.454V145.868Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.923 136.693H161.726C162.094 136.693 162.393 136.394 162.393 136.025V132.75C162.393 132.381 162.094 132.082 161.726 132.082H158.923C158.554 132.082 158.255 132.381 158.255 132.75V136.025C158.255 136.394 158.554 136.693 158.923 136.693",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.523 136.693H155.324C155.694 136.693 155.992 136.394 155.992 136.025V132.75C155.992 132.381 155.694 132.082 155.324 132.082H152.523C152.154 132.082 151.855 132.381 151.855 132.75V136.025C151.855 136.394 152.154 136.693 152.523 136.693",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.122 136.693H148.924C149.293 136.693 149.593 136.394 149.593 136.025V132.75C149.593 132.381 149.293 132.082 148.924 132.082H146.122C145.754 132.082 145.454 132.381 145.454 132.75V136.025C145.454 136.394 145.754 136.693 146.122 136.693",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.923 164.382H161.726C162.094 164.382 162.393 164.084 162.393 163.714V160.44C162.393 160.07 162.094 159.771 161.726 159.771H158.923C158.554 159.771 158.255 160.07 158.255 160.44V163.714C158.255 164.084 158.554 164.382 158.923 164.382",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.523 164.382H155.324C155.694 164.382 155.992 164.084 155.992 163.714V160.44C155.992 160.07 155.694 159.771 155.324 159.771H152.523C152.154 159.771 151.855 160.07 151.855 160.44V163.714C151.855 164.084 152.154 164.382 152.523 164.382",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.122 164.382H148.924C149.293 164.382 149.593 164.084 149.593 163.714V160.44C149.593 160.07 149.293 159.771 148.924 159.771H146.122C145.754 159.771 145.454 160.07 145.454 160.44V163.714C145.454 164.084 145.754 164.382 146.122 164.382",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.923 155.208H161.726C162.094 155.208 162.393 154.91 162.393 154.54V151.266C162.393 150.896 162.094 150.597 161.726 150.597H158.923C158.554 150.597 158.255 150.896 158.255 151.266V154.54C158.255 154.91 158.554 155.208 158.923 155.208",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.523 155.208H155.324C155.694 155.208 155.992 154.91 155.992 154.54V151.266C155.992 150.896 155.694 150.597 155.324 150.597H152.523C152.154 150.597 151.855 150.896 151.855 151.266V154.54C151.855 154.91 152.154 155.208 152.523 155.208",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.122 155.208H148.924C149.293 155.208 149.593 154.91 149.593 154.54V151.266C149.593 150.896 149.293 150.597 148.924 150.597H146.122C145.754 150.597 145.454 150.896 145.454 151.266V154.54C145.454 154.91 145.754 155.208 146.122 155.208",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.256 127.519H162.393V122.908H158.256V127.519Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.523 127.519H155.324C155.694 127.519 155.992 127.22 155.992 126.851V123.576C155.992 123.207 155.694 122.908 155.324 122.908H152.523C152.154 122.908 151.855 123.207 151.855 123.576V126.851C151.855 127.22 152.154 127.519 152.523 127.519",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.122 127.519H148.924C149.293 127.519 149.593 127.22 149.593 126.851V123.576C149.593 123.207 149.293 122.908 148.924 122.908H146.122C145.754 122.908 145.454 123.207 145.454 123.576V126.851C145.454 127.22 145.754 127.519 146.122 127.519",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.923 118.345H161.726C162.094 118.345 162.393 118.046 162.393 117.677V114.402C162.393 114.033 162.094 113.734 161.726 113.734H158.923C158.554 113.734 158.255 114.033 158.255 114.402V117.677C158.255 118.046 158.554 118.345 158.923 118.345",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.523 118.345H155.324C155.694 118.345 155.992 118.046 155.992 117.677V114.402C155.992 114.033 155.694 113.734 155.324 113.734H152.523C152.154 113.734 151.855 114.033 151.855 114.402V117.677C151.855 118.046 152.154 118.345 152.523 118.345",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.122 118.345H148.924C149.293 118.345 149.593 118.046 149.593 117.677V114.402C149.593 114.033 149.293 113.734 148.924 113.734H146.122C145.754 113.734 145.454 114.033 145.454 114.402V117.677C145.454 118.046 145.754 118.345 146.122 118.345",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.923 109.17H161.726C162.094 109.17 162.393 108.872 162.393 108.502V105.228C162.393 104.858 162.094 104.56 161.726 104.56H158.923C158.554 104.56 158.255 104.858 158.255 105.228V108.502C158.255 108.872 158.554 109.17 158.923 109.17",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.523 109.17H155.324C155.694 109.17 155.992 108.872 155.992 108.502V105.228C155.992 104.858 155.694 104.56 155.324 104.56H152.523C152.154 104.56 151.855 104.858 151.855 105.228V108.502C151.855 108.872 152.154 109.17 152.523 109.17",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.122 109.17H148.924C149.293 109.17 149.593 108.872 149.593 108.502V105.228C149.593 104.858 149.293 104.56 148.924 104.56H146.122C145.754 104.56 145.454 104.858 145.454 105.228V108.502C145.454 108.872 145.754 109.17 146.122 109.17",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.923 99.9966H161.726C162.094 99.9966 162.393 99.6979 162.393 99.3285V96.0538C162.393 95.6845 162.094 95.3857 161.726 95.3857H158.923C158.554 95.3857 158.255 95.6845 158.255 96.0538V99.3285C158.255 99.6979 158.554 99.9966 158.923 99.9966",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.523 99.9966H155.324C155.694 99.9966 155.992 99.6979 155.992 99.3285V96.0538C155.992 95.6845 155.694 95.3857 155.324 95.3857H152.523C152.154 95.3857 151.855 95.6845 151.855 96.0538V99.3285C151.855 99.6979 152.154 99.9966 152.523 99.9966",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.454 99.9966H148.924C149.293 99.9966 149.592 99.6979 149.592 99.3285V95.3857H145.454V99.9966Z",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.644 88.0269H128.268C128.637 88.0269 128.936 87.7282 128.936 87.3588V48.2091C128.936 47.8407 128.637 47.541 128.268 47.541H104.644C104.275 47.541 103.976 47.8407 103.976 48.2091V87.3588C103.976 87.7282 104.275 88.0269 104.644 88.0269",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.504 128.336H134.127C134.496 128.336 134.796 128.037 134.796 127.667V88.5177C134.796 88.1493 134.496 87.8506 134.127 87.8506H110.504C110.135 87.8506 109.836 88.1493 109.836 88.5177V127.667C109.836 128.037 110.135 128.336 110.504 128.336",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.453 178.054H142.935C143.343 178.054 143.674 177.723 143.674 177.316V129.252C143.674 128.844 143.343 128.513 142.935 128.513H119.453C119.045 128.513 118.714 128.844 118.714 129.252V177.316C118.714 177.723 119.045 178.054 119.453 178.054",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.43 128.461V87.8125H125.57V47.4554H119.692V29.9102H115.484V47.4554H106.648V29.9102H102.44V47.4554H95.2056V87.9566H89.3559V128.461H80.2268V178.239H139.953V128.461H131.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.886 177.854H131.606C131.975 177.854 132.274 177.555 132.274 177.186V158.484C132.274 158.115 131.975 157.815 131.606 157.815H127.886C127.516 157.815 127.218 158.115 127.218 158.484V177.186C127.218 177.555 127.516 177.854 127.886 177.854",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.347 177.854H123.067C123.436 177.854 123.735 177.555 123.735 177.186V158.484C123.735 158.115 123.436 157.815 123.067 157.815H119.347C118.977 157.815 118.678 158.115 118.678 158.484V177.186C118.678 177.555 118.977 177.854 119.347 177.854",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.807 177.854H114.528C114.897 177.854 115.196 177.555 115.196 177.186V158.484C115.196 158.115 114.897 157.815 114.528 157.815H110.807C110.438 157.815 110.139 158.115 110.139 158.484V177.186C110.139 177.555 110.438 177.854 110.807 177.854",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.268 177.854H105.989C106.358 177.854 106.658 177.555 106.658 177.186V158.484C106.658 158.115 106.358 157.815 105.989 157.815H102.268C101.9 157.815 101.6 158.115 101.6 158.484V177.186C101.6 177.555 101.9 177.854 102.268 177.854",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9553 177.854H97.2243C97.7177 177.854 98.1186 177.454 98.1186 176.959V158.71C98.1186 158.215 97.7177 157.815 97.2243 157.815H93.9553C93.4619 157.815 93.061 158.215 93.061 158.71V176.959C93.061 177.454 93.4619 177.854 93.9553 177.854",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1908 177.854H88.9112C89.2805 177.854 89.5793 177.555 89.5793 177.186V158.484C89.5793 158.115 89.2805 157.815 88.9112 157.815H85.1908C84.8214 157.815 84.5227 158.115 84.5227 158.484V177.186C84.5227 177.555 84.8214 177.854 85.1908 177.854",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.886 150.742H131.606C131.975 150.742 132.274 150.444 132.274 150.074V146.154C132.274 145.785 131.975 145.486 131.606 145.486H127.886C127.516 145.486 127.218 145.785 127.218 146.154V150.074C127.218 150.444 127.516 150.742 127.886 150.742",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.347 150.742H123.067C123.436 150.742 123.735 150.444 123.735 150.074V146.154C123.735 145.785 123.436 145.486 123.067 145.486H119.347C118.977 145.486 118.678 145.785 118.678 146.154V150.074C118.678 150.444 118.977 150.742 119.347 150.742",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.807 150.742H114.528C114.897 150.742 115.196 150.444 115.196 150.074V146.154C115.196 145.785 114.897 145.486 114.528 145.486H110.807C110.438 145.486 110.139 145.785 110.139 146.154V150.074C110.139 150.444 110.438 150.742 110.807 150.742",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.268 150.742H105.989C106.358 150.742 106.658 150.444 106.658 150.074V146.154C106.658 145.785 106.358 145.486 105.989 145.486H102.268C101.9 145.486 101.6 145.785 101.6 146.154V150.074C101.6 150.444 101.9 150.742 102.268 150.742",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7299 150.742H96.8976C97.5714 150.742 98.1183 150.195 98.1183 149.522V146.707C98.1183 146.032 97.5714 145.486 96.8976 145.486H94.2825C93.6087 145.486 93.0618 146.032 93.0618 146.707V150.074C93.0618 150.444 93.3605 150.742 93.7299 150.742",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1908 150.742H88.6726C89.1736 150.742 89.5793 150.337 89.5793 149.836V146.393C89.5793 145.892 89.1736 145.486 88.6726 145.486H85.4294C84.9283 145.486 84.5227 145.892 84.5227 146.393V150.074C84.5227 150.444 84.8214 150.742 85.1908 150.742",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.886 140.182H131.606C131.975 140.182 132.274 139.883 132.274 139.514V135.593C132.274 135.225 131.975 134.926 131.606 134.926H127.886C127.516 134.926 127.218 135.225 127.218 135.593V139.514C127.218 139.883 127.516 140.182 127.886 140.182",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.347 140.182H123.067C123.436 140.182 123.735 139.883 123.735 139.514V135.593C123.735 135.225 123.436 134.926 123.067 134.926H119.347C118.977 134.926 118.678 135.225 118.678 135.593V139.514C118.678 139.883 118.977 140.182 119.347 140.182",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.807 140.182H114.528C114.897 140.182 115.196 139.883 115.196 139.514V135.593C115.196 135.225 114.897 134.926 114.528 134.926H110.807C110.438 134.926 110.139 135.225 110.139 135.593V139.514C110.139 139.883 110.438 140.182 110.807 140.182",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.268 140.182H105.989C106.358 140.182 106.658 139.883 106.658 139.514V135.593C106.658 135.225 106.358 134.926 105.989 134.926H102.268C101.9 134.926 101.6 135.225 101.6 135.593V139.514C101.6 139.883 101.9 140.182 102.268 140.182",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7299 140.182H97.4502C97.8196 140.182 98.1183 139.883 98.1183 139.514V135.593C98.1183 135.225 97.8196 134.926 97.4502 134.926H93.7299C93.3605 134.926 93.0618 135.225 93.0618 135.593V139.514C93.0618 139.883 93.3605 140.182 93.7299 140.182",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1908 140.182H88.9112C89.2805 140.182 89.5793 139.883 89.5793 139.514V135.593C89.5793 135.225 89.2805 134.926 88.9112 134.926H85.1908C84.8214 134.926 84.5227 135.225 84.5227 135.593V139.514C84.5227 139.883 84.8214 140.182 85.1908 140.182",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.347 123.926H123.067C123.436 123.926 123.735 123.627 123.735 123.258V119.338C123.735 118.969 123.436 118.67 123.067 118.67H119.347C118.977 118.67 118.678 118.969 118.678 119.338V123.258C118.678 123.627 118.977 123.926 119.347 123.926",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.807 123.926H114.528C114.897 123.926 115.196 123.627 115.196 123.258V119.338C115.196 118.969 114.897 118.67 114.528 118.67H110.807C110.438 118.67 110.139 118.969 110.139 119.338V123.258C110.139 123.627 110.438 123.926 110.807 123.926",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.268 123.926H105.989C106.358 123.926 106.658 123.627 106.658 123.258V119.338C106.658 118.969 106.358 118.67 105.989 118.67H102.268C101.9 118.67 101.6 118.969 101.6 119.338V123.258C101.6 123.627 101.9 123.926 102.268 123.926",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7299 123.926H97.4502C97.8196 123.926 98.1183 123.627 98.1183 123.258V119.338C98.1183 118.969 97.8196 118.67 97.4502 118.67H93.7299C93.3605 118.67 93.0618 118.969 93.0618 119.338V123.258C93.0618 123.627 93.3605 123.926 93.7299 123.926",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 13,
    width: 356,
    height: 277
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 289.784H395.081V13.249H40V289.784Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.678 111.811H123.735V106.555H118.678V111.811Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.807 111.811H114.528C114.897 111.811 115.196 111.512 115.196 111.143V107.223C115.196 106.853 114.897 106.555 114.528 106.555H110.807C110.438 106.555 110.139 106.853 110.139 107.223V111.143C110.139 111.512 110.438 111.811 110.807 111.811",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.268 111.811H105.989C106.358 111.811 106.658 111.512 106.658 111.143V107.223C106.658 106.853 106.358 106.555 105.989 106.555H102.268C101.9 106.555 101.6 106.853 101.6 107.223V111.143C101.6 111.512 101.9 111.811 102.268 111.811",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7299 111.811H97.4502C97.8196 111.811 98.1183 111.512 98.1183 111.143V107.223C98.1183 106.853 97.8196 106.555 97.4502 106.555H93.7299C93.3605 106.555 93.0618 106.853 93.0618 107.223V111.143C93.0618 111.512 93.3605 111.811 93.7299 111.811",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.678 99.882H123.735V94.626H118.678V99.882Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.807 99.881H114.528C114.897 99.881 115.196 99.5823 115.196 99.2129V95.2931C115.196 94.9237 114.897 94.625 114.528 94.625H110.807C110.438 94.625 110.139 94.9237 110.139 95.2931V99.2129C110.139 99.5823 110.438 99.881 110.807 99.881",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.268 99.881H105.989C106.358 99.881 106.658 99.5823 106.658 99.2129V95.2931C106.658 94.9237 106.358 94.625 105.989 94.625H102.268C101.9 94.625 101.6 94.9237 101.6 95.2931V99.2129C101.6 99.5823 101.9 99.881 102.268 99.881",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7299 99.881H97.4502C97.8196 99.881 98.1183 99.5823 98.1183 99.2129V95.2931C98.1183 94.9237 97.8196 94.625 97.4502 94.625H93.7299C93.3605 94.625 93.0618 94.9237 93.0618 95.2931V99.2129C93.0618 99.5823 93.3605 99.881 93.7299 99.881",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.077 85.5207H118.797C119.167 85.5207 119.466 85.222 119.466 84.8526V80.9327C119.466 80.5634 119.167 80.2646 118.797 80.2646H115.077C114.708 80.2646 114.409 80.5634 114.409 80.9327V84.8526C114.409 85.222 114.708 85.5207 115.077 85.5207",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.538 85.5207H110.259C110.628 85.5207 110.927 85.222 110.927 84.8526V80.9327C110.927 80.5634 110.628 80.2646 110.259 80.2646H106.538C106.169 80.2646 105.87 80.5634 105.87 80.9327V84.8526C105.87 85.222 106.169 85.5207 106.538 85.5207",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9992 85.5207H102.388V80.2646H97.3311V84.8526C97.3311 85.222 97.6298 85.5207 97.9992 85.5207",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.077 76.3596H118.797C119.167 76.3596 119.466 76.0608 119.466 75.6915V71.7716C119.466 71.4023 119.167 71.1035 118.797 71.1035H115.077C114.708 71.1035 114.409 71.4023 114.409 71.7716V75.6915C114.409 76.0608 114.708 76.3596 115.077 76.3596",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.538 76.3596H110.259C110.628 76.3596 110.927 76.0608 110.927 75.6915V71.7716C110.927 71.4023 110.628 71.1035 110.259 71.1035H106.538C106.169 71.1035 105.87 71.4023 105.87 71.7716V75.6915C105.87 76.0608 106.169 76.3596 106.538 76.3596",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9992 76.3596H101.72C102.089 76.3596 102.388 76.0608 102.388 75.6915V71.7716C102.388 71.4023 102.089 71.1035 101.72 71.1035H97.9992C97.6298 71.1035 97.3311 71.4023 97.3311 71.7716V75.6915C97.3311 76.0608 97.6298 76.3596 97.9992 76.3596",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.077 67.1994H118.797C119.167 67.1994 119.466 66.9007 119.466 66.5313V62.6105C119.466 62.2421 119.167 61.9434 118.797 61.9434H115.077C114.708 61.9434 114.409 62.2421 114.409 62.6105V66.5313C114.409 66.9007 114.708 67.1994 115.077 67.1994",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.538 67.1994H110.259C110.628 67.1994 110.927 66.9007 110.927 66.5313V62.6105C110.927 62.2421 110.628 61.9434 110.259 61.9434H106.538C106.169 61.9434 105.87 62.2421 105.87 62.6105V66.5313C105.87 66.9007 106.169 67.1994 106.538 67.1994",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9992 67.1994H101.72C102.089 67.1994 102.388 66.9007 102.388 66.5313V62.6105C102.388 62.2421 102.089 61.9434 101.72 61.9434H97.9992C97.6298 61.9434 97.3311 62.2421 97.3311 62.6105V66.5313C97.3311 66.9007 97.6298 67.1994 97.9992 67.1994",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.077 58.0373H118.797C119.167 58.0373 119.466 57.7386 119.466 57.3692V53.4494C119.466 53.08 119.167 52.7812 118.797 52.7812H115.077C114.708 52.7812 114.409 53.08 114.409 53.4494V57.3692C114.409 57.7386 114.708 58.0373 115.077 58.0373",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.538 58.0373H110.259C110.628 58.0373 110.927 57.7386 110.927 57.3692V53.4494C110.927 53.08 110.628 52.7812 110.259 52.7812H106.538C106.169 52.7812 105.87 53.08 105.87 53.4494V57.3692C105.87 57.7386 106.169 58.0373 106.538 58.0373",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9992 58.0373H101.72C102.089 58.0373 102.388 57.7386 102.388 57.3692V53.4494C102.388 53.08 102.089 52.7812 101.72 52.7812H97.9992C97.6298 52.7812 97.3311 53.08 97.3311 53.4494V57.3692C97.3311 57.7386 97.6298 58.0373 97.9992 58.0373",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.521 128.204V87.8058H123.661V47.4096H117.784V29.9102H113.576V47.4096H104.74V29.9102H100.531V47.4096H93.2969V87.8058H87.4472V128.204H78.3181V177.853H138.044V128.204H129.521Z",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.749 32.6644V15.833",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.793 32.6155V15.7842",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8788 175.948H83.5019C83.8712 175.948 84.1709 175.649 84.1709 175.28V92.466C84.1709 92.0966 83.8712 91.7979 83.5019 91.7979H59.8788C59.5094 91.7979 59.2107 92.0966 59.2107 92.466V175.28C59.2107 175.649 59.5094 175.948 59.8788 175.948",
    fill: "#0A2A49"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 13,
    width: 356,
    height: 277
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 289.784H395.081V13.249H40V289.784Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5037 175.948H80.4639V91.7979H55.5037V175.948Z",
    fill: "#EDCCE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5037 175.948H80.4639V91.7979H55.5037V175.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0678 175.684H77.6908C78.0602 175.684 78.3599 175.386 78.3599 175.016V92.2023C78.3599 91.8339 78.0602 91.5342 77.6908 91.5342H54.0678C53.6984 91.5342 53.3997 91.8339 53.3997 92.2023V175.016C53.3997 175.386 53.6984 175.684 54.0678 175.684Z",
    stroke: "#0A2A49",
    strokeWidth: 1.131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1846 149.34H75.322V145.398C75.322 145.028 75.0233 144.729 74.6539 144.729H71.1846V149.34Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.452 149.34H68.2542C68.6226 149.34 68.9214 149.042 68.9214 148.672V145.398C68.9214 145.028 68.6226 144.729 68.2542 144.729H65.452C65.0827 144.729 64.7839 145.028 64.7839 145.398V148.672C64.7839 149.042 65.0827 149.34 65.452 149.34",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3833 149.34H62.5208V144.729H58.3833V149.34Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8524 140.166H74.6546C75.023 140.166 75.3227 139.867 75.3227 139.497V136.223C75.3227 135.853 75.023 135.554 74.6546 135.554H71.8524C71.484 135.554 71.1843 135.853 71.1843 136.223V139.497C71.1843 139.867 71.484 140.166 71.8524 140.166",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.452 140.166H68.2542C68.6226 140.166 68.9214 139.867 68.9214 139.497V136.223C68.9214 135.853 68.6226 135.554 68.2542 135.554H65.452C65.0827 135.554 64.7839 135.853 64.7839 136.223V139.497C64.7839 139.867 65.0827 140.166 65.452 140.166",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0516 140.166H61.8529C62.2223 140.166 62.521 139.867 62.521 139.497V136.223C62.521 135.853 62.2223 135.554 61.8529 135.554H59.0516C58.6823 135.554 58.3835 135.853 58.3835 136.223V139.497C58.3835 139.867 58.6823 140.166 59.0516 140.166",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8524 167.855H74.6546C75.023 167.855 75.3227 167.556 75.3227 167.187V163.912C75.3227 163.543 75.023 163.243 74.6546 163.243H71.8524C71.484 163.243 71.1843 163.543 71.1843 163.912V167.187C71.1843 167.556 71.484 167.855 71.8524 167.855",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.452 167.855H68.2542C68.6226 167.855 68.9214 167.556 68.9214 167.187V163.912C68.9214 163.543 68.6226 163.243 68.2542 163.243H65.452C65.0827 163.243 64.7839 163.543 64.7839 163.912V167.187C64.7839 167.556 65.0827 167.855 65.452 167.855",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0516 167.855H61.8529C62.2223 167.855 62.521 167.556 62.521 167.187V163.912C62.521 163.543 62.2223 163.243 61.8529 163.243H59.0516C58.6823 163.243 58.3835 163.543 58.3835 163.912V167.187C58.3835 167.556 58.6823 167.855 59.0516 167.855",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8524 158.68H74.6546C75.023 158.68 75.3227 158.381 75.3227 158.012V154.737C75.3227 154.368 75.023 154.068 74.6546 154.068H71.8524C71.484 154.068 71.1843 154.368 71.1843 154.737V158.012C71.1843 158.381 71.484 158.68 71.8524 158.68",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.452 158.68H68.2542C68.6226 158.68 68.9214 158.381 68.9214 158.012V154.737C68.9214 154.368 68.6226 154.068 68.2542 154.068H65.452C65.0827 154.068 64.7839 154.368 64.7839 154.737V158.012C64.7839 158.381 65.0827 158.68 65.452 158.68",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0516 158.68H61.8529C62.2223 158.68 62.521 158.381 62.521 158.012V154.737C62.521 154.368 62.2223 154.068 61.8529 154.068H59.0516C58.6823 154.068 58.3835 154.368 58.3835 154.737V158.012C58.3835 158.381 58.6823 158.68 59.0516 158.68",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1851 130.992H75.3225V126.38H71.1851V130.992Z",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.452 130.992H68.2542C68.6226 130.992 68.9214 130.693 68.9214 130.324V127.049C68.9214 126.68 68.6226 126.38 68.2542 126.38H65.452C65.0827 126.38 64.7839 126.68 64.7839 127.049V130.324C64.7839 130.693 65.0827 130.992 65.452 130.992",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0516 130.992H61.8529C62.2223 130.992 62.521 130.693 62.521 130.324V127.049C62.521 126.68 62.2223 126.38 61.8529 126.38H59.0516C58.6823 126.38 58.3835 126.68 58.3835 127.049V130.324C58.3835 130.693 58.6823 130.992 59.0516 130.992",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8524 121.817H74.6546C75.023 121.817 75.3227 121.518 75.3227 121.149V117.874C75.3227 117.505 75.023 117.205 74.6546 117.205H71.8524C71.484 117.205 71.1843 117.505 71.1843 117.874V121.149C71.1843 121.518 71.484 121.817 71.8524 121.817",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.452 121.817H68.2542C68.6226 121.817 68.9214 121.518 68.9214 121.149V117.874C68.9214 117.505 68.6226 117.205 68.2542 117.205H65.452C65.0827 117.205 64.7839 117.505 64.7839 117.874V121.149C64.7839 121.518 65.0827 121.817 65.452 121.817",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0516 121.817H61.8529C62.2223 121.817 62.521 121.518 62.521 121.149V117.874C62.521 117.505 62.2223 117.205 61.8529 117.205H59.0516C58.6823 117.205 58.3835 117.505 58.3835 117.874V121.149C58.3835 121.518 58.6823 121.817 59.0516 121.817",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8524 112.643H74.6546C75.023 112.643 75.3227 112.344 75.3227 111.975V108.7C75.3227 108.331 75.023 108.031 74.6546 108.031H71.8524C71.484 108.031 71.1843 108.331 71.1843 108.7V111.975C71.1843 112.344 71.484 112.643 71.8524 112.643",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.452 112.643H68.2542C68.6226 112.643 68.9214 112.344 68.9214 111.975V108.7C68.9214 108.331 68.6226 108.031 68.2542 108.031H65.452C65.0827 108.031 64.7839 108.331 64.7839 108.7V111.975C64.7839 112.344 65.0827 112.643 65.452 112.643",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0516 112.643H61.8529C62.2223 112.643 62.521 112.344 62.521 111.975V108.7C62.521 108.331 62.2223 108.031 61.8529 108.031H59.0516C58.6823 108.031 58.3835 108.331 58.3835 108.7V111.975C58.3835 112.344 58.6823 112.643 59.0516 112.643",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8524 103.468H74.6546C75.023 103.468 75.3227 103.17 75.3227 102.8V99.5255C75.3227 99.1561 75.023 98.8564 74.6546 98.8564H71.8524C71.484 98.8564 71.1843 99.1561 71.1843 99.5255V102.8C71.1843 103.17 71.484 103.468 71.8524 103.468",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.452 103.468H68.2542C68.6226 103.468 68.9214 103.17 68.9214 102.8V99.5255C68.9214 99.1561 68.6226 98.8564 68.2542 98.8564H65.452C65.0827 98.8564 64.7839 99.1561 64.7839 99.5255V102.8C64.7839 103.17 65.0827 103.468 65.452 103.468",
    fill: "#7ECECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3833 103.468H61.8527C62.222 103.468 62.5208 103.17 62.5208 102.8V98.8564H58.3833V103.468Z",
    fill: "#7ECECA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.951 196.7C571.607 191.777 578.841 189.34 579.365 184.442C579.622 182.049 577.892 179.585 575.549 179.003C574.691 178.79 573.793 178.839 572.956 179.097C571.513 179.541 570.072 178.384 570.228 176.882L571.402 165.587C571.603 163.662 569.293 162.509 567.889 163.834C566.75 164.91 564.865 164.375 564.442 162.857L561.995 154.068C561.648 152.821 560.263 152.173 559.098 152.721C557.844 153.31 556.168 153.371 554.91 152.71C552.493 151.443 551.087 148.866 549.048 147.049C547.01 145.233 543.36 144.457 541.879 146.724C547.206 150.037 553.243 154.685 552.644 160.896C552.466 162.737 551.672 164.435 550.508 165.868C549.503 167.106 550.216 168.973 551.797 169.241C553.299 169.495 554.756 169.945 556.101 170.666C558.965 172.202 561.228 175.158 561.231 178.392C561.234 180.549 560.009 182.678 558.235 183.808C556.927 184.64 556.885 186.557 558.237 187.336C559.578 188.108 561.101 188.571 562.639 188.672C564.158 188.772 565.038 190.465 564.291 191.783C563.233 193.654 562.204 195.53 561.691 197.609C559.986 204.501 565.92 214.777 574.042 212.593C585.151 209.605 572.283 201.469 571.951 196.7",
    fill: "#DCF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.561 191.389C573.207 190.771 576.508 192.124 578.289 189.816C578.976 188.925 579.156 187.742 578.898 186.643C578.263 183.933 576.067 182.354 574.548 180.268C574.537 180.252 574.526 180.236 574.515 180.22C573.389 178.652 575.05 176.634 576.828 177.361C578.43 178.018 580.238 178.172 581.906 177.704C584.923 176.859 587.294 174.04 587.626 170.9C587.864 168.662 587.155 166.391 587.887 164.166C588.196 163.229 588.792 162.392 589.67 161.952C592.603 160.477 595.275 164.722 598.338 162.651C599.044 162.174 599.57 161.466 599.895 160.675C601.154 157.614 599.822 154.246 601.438 151.253C601.961 150.285 602.842 149.531 603.917 149.33C606.289 148.887 607.589 151.251 609.529 152.179C612.406 153.554 615.82 151.396 617.56 148.708C619.302 146.02 620.11 142.774 622.035 140.217C624.14 137.421 628.53 135.701 630.987 138.612C631.976 139.782 632.275 141.387 631.95 142.889C631.302 145.877 628.845 147.793 626.264 149.073C624.159 150.119 621.897 150.833 619.837 151.969C618.279 152.828 616.815 153.963 615.923 155.511C615.03 157.058 614.797 159.073 615.657 160.64C617.041 163.161 620.866 164.157 621.006 167.104C621.087 168.809 619.856 170.262 618.223 170.707C615.316 171.499 612.785 169.925 610.437 168.444C608.073 166.953 605.467 165.427 602.564 166.404C601.003 166.93 599.905 168.448 600.084 170.098C600.292 172.028 602.167 173.12 603.759 174.127C605.285 175.094 606.89 176.63 606.523 178.409C606.048 180.714 602.859 181.055 600.64 180.325C598.336 179.568 595.83 178.248 593.659 179.467C591.775 180.523 591.103 182.911 591.911 184.926C591.929 184.971 591.947 185.015 591.965 185.059C592.907 187.289 591.098 189.711 588.711 189.436L585.301 189.043C584.28 188.926 583.23 189.162 582.413 189.79C579.49 192.038 582.584 196.262 584.51 197.755C586.235 199.091 587.451 201.021 587.671 203.203C588.564 212.011 575.222 211.363 570.709 208.007C566.225 204.672 562.964 193.166 570.561 191.389",
    fill: "#DCF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M602.166 162.651C602.872 162.173 603.396 161.465 603.723 160.674C604.982 157.614 603.65 154.246 605.266 151.253C605.462 150.889 605.721 150.572 606.01 150.287C605.129 149.613 604.197 149.103 602.983 149.33C601.909 149.531 601.028 150.284 600.505 151.253C598.889 154.246 600.221 157.614 598.962 160.674C598.675 161.373 598.224 161.995 597.639 162.462C599.104 163.104 600.583 163.721 602.166 162.651",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.016 189.349L587.778 189.436C588.437 189.512 589.041 189.368 589.566 189.095L589.128 189.044C588.406 188.961 587.674 189.065 587.016 189.349",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.357 152.179C616.233 153.554 619.648 151.396 621.388 148.708C623.128 146.018 623.936 142.773 625.862 140.217C626.657 139.162 627.777 138.26 628.996 137.703C626.483 136.175 622.931 137.787 621.101 140.217C619.175 142.773 618.368 146.018 616.628 148.708C615.751 150.06 614.453 151.276 613.011 151.978C613.127 152.045 613.238 152.122 613.357 152.179",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.264 168.444C611.901 166.952 609.294 165.426 606.392 166.405C606.248 166.452 606.114 166.517 605.979 166.582C607.21 167.034 608.385 167.738 609.504 168.444C611.852 169.925 614.381 171.498 617.289 170.708C617.533 170.642 617.762 170.547 617.983 170.439C616.681 169.961 615.449 169.192 614.264 168.444",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.486 179.467C597.459 179.482 597.437 179.503 597.412 179.519C598.185 179.778 598.957 180.079 599.706 180.326C601.103 180.784 602.879 180.816 604.126 180.205C601.917 179.441 599.551 178.308 597.486 179.467",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.536 208.007C570.052 204.672 566.791 193.165 574.388 191.389C576.381 190.923 578.746 191.574 580.552 190.939C580.745 190.522 581.036 190.133 581.479 189.79C581.768 189.57 582.092 189.414 582.426 189.287C582.837 188.484 582.936 187.54 582.725 186.643C582.091 183.933 579.894 182.353 578.376 180.267C578.365 180.252 578.353 180.236 578.342 180.22C577.786 179.445 577.913 178.561 578.397 177.952C577.54 177.89 576.692 177.689 575.894 177.362C574.116 176.634 572.455 178.653 573.581 180.22C573.592 180.236 573.603 180.252 573.615 180.267C575.133 182.353 577.329 183.933 577.964 186.643C578.222 187.743 578.042 188.925 577.355 189.817C575.576 192.122 572.274 190.771 569.627 191.389C562.031 193.165 565.291 204.672 569.776 208.007C572.075 209.718 576.666 210.721 580.499 210.132C578.125 209.806 575.917 209.034 574.536 208.007",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.321 177.576C582.749 178.024 584.291 178.108 585.735 177.704C588.75 176.859 591.12 174.039 591.454 170.899C591.692 168.662 590.982 166.391 591.714 164.167C591.933 163.5 592.306 162.892 592.813 162.434C591.466 161.843 590.13 161.251 588.736 161.952C587.86 162.393 587.263 163.23 586.954 164.167C586.221 166.391 586.931 168.662 586.694 170.899C586.373 173.915 584.166 176.617 581.321 177.576",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.401 168.19C553.729 169.218 558.661 172.126 563.214 175.312C565.498 176.909 567.757 178.623 569.481 180.792C570.975 182.674 571.724 184.103 572.994 187.206C573.257 187.85 572.667 188.523 571.99 188.356C564.124 186.417 562.689 186.522 555.598 180.88C555.384 180.711 555.263 180.446 555.275 180.173C555.314 179.363 554.881 178.18 554.832 177.3C554.81 176.905 554.513 176.569 554.12 176.52C552.803 176.358 551.479 176.458 550.255 176.813C549.706 176.972 549.163 176.558 549.173 175.985C549.185 175.337 549.195 174.689 549.207 174.039C549.215 173.576 548.851 173.172 548.387 173.173C546.679 173.174 545.017 173.606 543.6 174.407C543.027 174.73 542.319 174.362 542.302 173.706C542.287 173.197 542.274 172.689 542.26 172.181C542.243 171.545 531.318 172.553 537.877 169.321C540.989 167.787 544.796 167.496 548.401 168.19",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M572.872 187.505C571.604 184.403 570.854 182.974 569.36 181.092C567.636 178.923 565.377 177.209 563.093 175.611C558.54 172.426 553.607 169.517 548.279 168.49C544.675 167.796 540.869 168.087 537.757 169.621C536.091 170.441 535.556 170.987 535.68 171.357C535.894 171.238 536.125 171.114 536.396 170.981C539.509 169.447 543.316 169.156 546.919 169.85C552.247 170.877 557.18 173.786 561.732 176.971C564.017 178.57 566.276 180.283 567.999 182.453C569.437 184.262 570.19 185.669 571.375 188.535C571.541 188.575 571.696 188.613 571.869 188.656C572.546 188.823 573.135 188.15 572.872 187.505",
    fill: "#63498C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.657 168.737C550.657 168.737 585.909 176.559 570.154 212.717",
    stroke: "white",
    strokeWidth: 1.34038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.482 155.679C562.538 155.536 562.638 154.059 562.618 151.826C562.615 151.359 562.99 150.969 563.459 150.96C566.263 150.911 569.089 150.952 571.932 151.084C570.778 150.971 568.717 149.333 567.536 148.764C566.011 148.011 564.479 147.309 562.945 146.655C562.734 146.565 562.539 146.478 562.358 146.397C562.204 144.576 561.967 142.628 561.659 140.701C561.585 140.235 561.898 139.794 562.365 139.718C564.259 139.417 566.166 139.151 568.087 138.924C566.949 139.011 564.853 138.043 563.681 137.777C562.972 137.609 562.263 137.452 561.556 137.3C561.228 137.232 560.976 136.974 560.906 136.646C560.05 132.582 558.982 129.225 558.703 128.359C558.656 128.211 558.653 128.065 558.69 127.915C559.36 125.171 559.911 122.354 560.334 119.475C561.075 119.283 561.122 119.271 561.864 119.081C573.369 134.975 579.787 153.034 581.039 170.985C581.094 171.788 580.093 172.206 579.551 171.612C577.572 169.438 574.338 165.975 571.104 163.09C566.72 158.999 562.333 155.993 562.482 155.679",
    fill: "#249A9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M572.356 121.169C572.71 121.481 573.828 122.466 575.407 123.969C575.728 124.276 575.761 124.782 575.481 125.128C573.581 127.461 571.761 129.69 572.452 129.468C572.99 129.295 575.537 128.488 578.46 127.649C578.765 127.562 579.093 127.644 579.312 127.873C582.062 130.752 585.202 134.393 588.085 138.267C588.352 138.627 588.3 139.129 587.961 139.421C585.304 141.712 580.083 145.924 581.129 145.744C581.964 145.615 587.424 144.897 591.868 144.5C592.185 144.472 592.49 144.627 592.662 144.896C597.093 151.817 599.826 158.085 599.746 158.554C599.652 159.207 595.494 163.51 591.006 167.097C586.565 170.772 581.792 173.732 581.516 173.704C581.476 173.699 581.358 173.593 581.175 173.407C580.359 154.772 573.963 135.913 562.075 119.374C561.605 118.72 562.204 117.824 562.981 118.04C566.008 118.88 569.046 119.867 572.08 121.003C572.181 121.042 572.275 121.097 572.356 121.169",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.665 119.959C560.924 120.149 560.877 120.162 560.136 120.353C560.1 120.589 560.052 120.817 560.015 121.052C571.341 136.725 577.714 154.494 579.079 172.191C579.169 172.288 579.268 172.397 579.353 172.49C579.895 173.085 580.896 172.666 580.84 171.864C579.588 153.912 573.172 135.853 561.665 119.959",
    fill: "#20898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.813 213.851C569.813 213.851 581.027 197.153 581.148 173.498C581.236 156.418 575.316 136.615 561.766 119.203",
    stroke: "white",
    strokeWidth: 1.34038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M631.629 162.774C619.218 165.909 607.39 172.1 597.437 180.669C605.641 180.824 613.699 182.95 620.795 186.83C624.148 188.665 627.432 190.933 631.278 191.306C632.205 187.621 631.866 183.681 630.336 180.358C633.66 181.663 636.982 182.97 640.304 184.275C641.657 184.65 643.206 183.709 643.869 182.376C644.53 181.044 644.429 179.453 643.915 178.118C643.399 176.783 642.514 175.656 641.619 174.569C644.458 175.617 647.298 176.663 650.137 177.711C650.758 177.94 651.388 178.17 652.055 178.222C653.863 178.365 655.573 177.193 657.046 176.003C660.232 173.431 663.157 170.507 665.752 167.306C666.467 166.423 668.99 163.983 668.558 162.754C668.216 161.782 664.992 161.653 664.092 161.497C657.236 160.3 650.174 160.053 643.153 160.754C639.286 161.14 635.43 161.814 631.629 162.774",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M631.629 165.976C635.43 165.016 639.286 164.342 643.153 163.956C650.174 163.255 657.236 163.502 664.092 164.699C664.721 164.809 666.471 164.91 667.593 165.291C668.255 164.42 668.773 163.509 668.558 162.897C668.216 161.924 664.992 161.795 664.092 161.638C657.236 160.442 650.174 160.194 643.153 160.896C639.286 161.281 635.43 161.955 631.629 162.915C619.218 166.052 607.39 172.242 597.437 180.81C598.613 180.832 599.784 180.907 600.951 181.009C610.125 173.921 620.647 168.751 631.629 165.976",
    fill: "#63498C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.888 212.573C570.888 212.573 601.098 148.56 668.558 162.755",
    stroke: "white",
    strokeWidth: 1.34038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1312 172.234C55.5601 168.986 57.1795 165.177 59.2656 161.951C61.8196 158.002 65.0926 154.902 68.0573 153.498C68.8444 153.124 69.6219 154.045 69.1308 154.764C67.7758 156.743 66.3002 158.57 64.7685 160.158C64.3079 160.634 64.5674 161.435 65.2169 161.571L66.3489 161.809C66.9838 161.943 67.2396 162.71 66.8205 163.206C65.8639 164.34 64.8477 165.323 63.8314 166.102C63.3257 166.49 63.4025 167.265 63.9764 167.542L65.4655 168.258C65.9712 168.502 66.1113 169.155 65.7445 169.579C64.5345 170.98 62.3119 173.737 61.9707 174.117C60.8607 175.355 58.9232 177.918 57.7668 178.344C55.4516 179.198 54.7851 174.855 55.1312 172.234",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8515 172.234C58.2804 168.985 59.8998 165.176 61.9872 161.951C64.2061 158.518 66.6517 155.928 69.2837 154.334C69.2837 153.796 68.9608 153.231 68.3978 153.498C65.4332 154.902 62.159 158.002 59.6062 161.951C57.5201 165.176 55.8994 168.985 55.4705 172.234C55.1257 174.855 55.7922 179.198 58.1074 178.344C58.3231 178.263 58.5717 178.093 58.8312 177.887C57.8661 176.735 57.609 174.067 57.8515 172.234",
    fill: "#63498C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0578 153.498C68.0578 153.498 45.5139 165.838 58.2036 194.978",
    stroke: "white",
    strokeWidth: 1.34038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2092 153.66C30.2421 161.21 32.5305 169.125 36.5869 175.92C37.0305 176.661 38.1905 176.329 38.171 175.465C37.9968 167.854 40.5618 160.676 45.2129 155.938C45.632 155.513 45.5273 154.81 44.9887 154.555C44.4696 154.309 43.9493 154.063 43.4302 153.817C42.8599 153.548 42.7697 152.774 43.262 152.38C44.4269 151.449 45.5918 150.518 46.7555 149.588C47.1491 149.273 47.1857 148.687 46.8347 148.326L43.206 144.599C42.816 144.199 42.9099 143.539 43.3961 143.262C45.3445 142.156 47.2929 141.049 49.2413 139.943C49.7104 139.677 49.8031 139.057 49.4558 138.644C46.5411 135.178 45.0667 131.187 44.1893 126.874C44.0626 126.255 43.3339 125.958 42.838 126.349C35.2393 132.334 30.1288 142.351 30.2092 153.66",
    fill: "#249A9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9366 154.679C32.8599 143.86 37.4305 134.327 44.4894 128.273C44.4687 128.178 44.4395 128.059 44.42 127.963C44.2945 127.344 43.6816 126.977 43.1844 127.368C35.5869 133.354 30.4752 143.371 30.5556 154.679C30.5885 162.229 32.8769 170.145 36.9346 176.939C37.3769 177.68 38.5382 177.349 38.5175 176.485C38.5101 176.165 38.5357 175.854 38.5382 175.537C34.9801 169.066 32.9671 161.72 32.9366 154.679",
    fill: "#20898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8383 126.349C42.8383 126.349 6.26797 157.031 58.1418 198.441",
    stroke: "white",
    strokeWidth: 1.34038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25408 127.525C5.01687 134.836 6.95067 143.568 9.44133 150.498C11.6895 156.748 15.3829 161.839 19.6465 165.72C20.1826 166.208 21.0527 165.861 21.0795 165.137C21.3268 158.533 23.2521 151.975 26.4666 146.847C26.7066 146.465 26.6323 145.937 26.246 145.702C24.1343 144.421 20.6164 147.182 19.1895 144.527C18.367 142.993 19.0774 140.616 20.2801 139.523C21.484 138.43 22.9864 138.269 24.4121 138.131C25.6904 138.008 27.0356 137.841 28.153 136.988C28.4223 136.782 28.5125 136.411 28.4259 136.082C27.7277 133.402 24.0258 133.571 23.0522 130.783C22.3394 128.737 23.6335 126.154 25.2468 125.363C26.4471 124.774 27.7253 124.884 28.9791 125.178C29.5726 125.317 30.1173 124.8 30.0051 124.2C29.4349 121.144 27.5108 113.91 19.744 114.655C12.4681 115.353 8.97342 121.906 7.25408 127.525",
    fill: "#7759A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7006 150.497C10.2099 143.567 8.27611 134.836 10.5133 127.524C12.1998 122.011 15.6068 115.612 22.6084 114.713C21.8432 114.598 21.0073 114.566 20.0848 114.654C12.8078 115.352 9.31307 121.905 7.59496 127.524C5.35653 134.836 7.29154 143.567 9.78221 150.497C12.0292 156.748 15.7237 161.837 19.9873 165.72C20.5235 166.207 21.3923 165.861 21.4203 165.137C21.4301 164.87 21.4593 164.607 21.4752 164.342C17.822 160.658 14.6916 156.035 12.7006 150.497",
    fill: "#63498C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0049 124.2C30.0049 124.2 28.048 109.687 15.2949 115.809C15.2949 115.809 4.41349 122.27 6.79449 139.612C6.79449 139.612 5.77337 161.036 51.0001 197.081",
    stroke: "white",
    strokeWidth: 1.34038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4252 194.82C14.6043 192.053 15.277 187.256 13.2091 183.888C7.78427 175.061 -9.47125 183.214 -14.8315 174.347C-18.2836 168.638 -13.691 159.58 -18.8478 155.346C-20.416 154.058 -22.5192 153.655 -24.2958 152.673C-26.0712 151.69 -27.609 149.568 -26.7585 147.726C-25.5887 145.19 -21.8052 146.06 -19.3145 147.325L3.7802 159.048C9.44146 161.922 15.2575 164.915 19.3822 169.741C22.0288 172.837 23.9078 176.615 27.0199 179.243C30.617 182.282 35.3924 183.41 39.8717 184.865C44.6995 186.432 60.2235 191.219 62.0634 196.562C63.5646 200.919 58.5212 205.186 54.1369 205.083C47.1182 204.916 43.7843 195.526 36.355 194.474C30.556 193.654 22.3749 199.676 17.4252 194.82",
    fill: "#DCF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.687 202.873C49.6683 202.706 46.3345 193.316 38.9051 192.264C33.1062 191.445 24.9262 197.466 19.9766 192.61C17.1545 189.843 17.8283 185.046 15.7593 181.678C10.3344 172.851 -6.91991 181.004 -12.2814 172.137C-15.7323 166.428 -11.1397 157.369 -16.2965 153.136C-17.8659 151.848 -19.9691 151.445 -21.7445 150.463C-23.2177 149.648 -24.5044 148.051 -24.424 146.479C-25.4451 146.61 -26.3018 147.077 -26.7587 148.066C-27.6092 149.91 -26.0715 152.03 -24.2948 153.013C-22.5195 153.995 -20.4163 154.399 -18.8468 155.687C-13.69 159.92 -18.2827 168.978 -14.8306 174.688C-9.47028 183.554 7.78523 175.401 13.2089 184.228C15.2779 187.595 14.6041 192.393 17.425 195.161C22.3758 200.018 30.5558 193.995 36.3548 194.816C43.7841 195.866 47.118 205.256 54.1367 205.423C56.9247 205.489 59.971 203.785 61.4405 201.418C60.0063 202.352 58.3028 202.912 56.687 202.873",
    fill: "#C8DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0278 170.462C77.068 168.975 76.7231 167.295 74.8953 167.103C73.1687 166.922 71.0229 168.289 70.0371 169.729C69.0513 171.171 68.8965 172.657 68.6333 174.105C68.1581 176.732 67.2503 179.423 65.9392 182.092C65.1739 183.651 63.9445 185.463 61.9241 186.123C59.7747 186.826 58.0773 185.788 57.0598 184.651C52.8961 180.001 52.9083 173.237 50.5772 167.605C50.1849 166.656 49.3807 165.623 47.8928 165.964C46.918 166.187 46.0663 166.972 45.7263 167.72C45.3863 168.469 45.4546 169.188 45.5837 169.858C46.7925 176.147 52.784 180.688 52.098 187.482C50.3189 188.252 48.4595 188.019 47.1203 187.436C45.7799 186.853 44.76 185.963 43.3904 185.412C42.0196 184.861 40.0931 184.71 38.353 185.565C36.3851 186.533 35.3725 188.521 35.7856 189.901C36.1974 191.279 37.7267 192.104 39.4716 192.491C41.2165 192.878 43.1966 192.893 45.0915 193.045C46.985 193.196 48.8603 193.505 50.1179 194.397C51.2438 195.195 51.7836 196.392 52.3989 197.518C53.2726 199.118 55.5062 201.796 58.9205 200.112C60.1926 199.484 61.1772 198.251 62.1191 197.375C63.351 196.231 64.572 195.098 65.7016 193.902C70.1248 189.222 73.4234 184.09 75.2901 179.005C76.3539 176.107 76.9534 173.225 77.0278 170.462",
    fill: "#DCF0EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 46.5794,
    y1: 29.1121,
    x2: 46.5794,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CD3CD",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletConfirmation);
export default __webpack_public_path__ + "static/media/tablet_confirmation.b4ab9cdecbf9ce03704500bf8f509934.svg";
export { ForwardRef as ReactComponent };